/* eslint-disable prettier */
/**
 * He resource file
 */

import {
	roles,
	daySelection,
	GARoleTypeId,
	toggleCCPEntityDetail,
	readinessReportCategories,
	archiveReportQualifiedTypeId,
	natureOfEngagements,
	dashboardTabId,
	dashboardViews as dashboardViewsConstants,
	accountDesignations,
	groupRiskStatus,
	riskTypeIds
} from '../util/uiconstants';

export const labels = {
	clearFilter: 'נקה הכל',
	canvasOversight: 'Canvas Oversight',
	oversight: 'השמטה',
	canvasLabel: 'Canvas',
	myProjects: 'הפרוייקטים שלי',
	otherProjects: 'פרויקטים אחרים',
	priorProjects: 'פרוייקטים קודמים',
	completedProjects: 'פרוייקטים שהושלמו',
	completedLabel: 'הושלם',
	createProject: 'צור פרוייקט',
	rollForward: 'גלגל קדימה',
	rollForwardLabel: 'גלגל קדימה',
	rollForwardTitle: 'גלגול קדימה של הפרוייקט',
	project: 'פרויקט',
	openProject: 'פרוייקט פתוח',
	manageUsers: 'ניהול משתמשים',
	rollForwardInstructionalText: 'האם אתה בטוח שאתה רוצה לקדם את הפרויקט שלך? <br> זה יאפשר לך להשתמש בפרויקט שהושלם כתבנית בעת יצירת פרויקט חדש. המידע הבא יתגלגל קדימה: שם הפרויקט, תרשים ארגוני, קבוצות ומנהלי קבוצות.',
	isClientUserError: 'אין לך פרוייקטים פעילים. שוחח עם חבר צוות  מ- EY בכדי להיות מוזמן לפרוייקט.',
	activeProjects: 'פרוייקטים פעילים',
	myActiveProjects: 'הפרויקטים הפעילים שלי',
	otherActiveProjects: 'פרויקטים פעילים אחרים',
	myCompletedProjects: 'הפרויקטים שלי שהושלמו',
	myActiveProjectsPlaceholder: 'יש לך גישה לפרויקטים של EY Canvas Oversight המפורטים כאן. בחר שם פרוייקט כדי לפתוח אותו או לחץ על מספר בכדי לראות פרטים.',
	deleteProject: 'מחק פרויקט',
	deleteProjectModalText: 'האם אתה בטוח שברצונך למחוק את הפרויקט הזה?<br>הפרויקט יוסר מדף הנחיתה שלך ולא יהיה נגיש יותר לכל חברי הצוות.',
	createButton: 'צור פרוייקט',
	search: 'חפש',
	searchEngagement: 'חפש תיק ביקורת',
	searchEngagements: 'חיפוש תיקי ביקורת',
	searchEntitiesAndEngagements: 'חיפוש ישויות ומעורבות',
	searchClientList: 'חפש שם לקוח',
	noDataFound: 'אין נתונים להצגה',
	expand: 'הרחב',
	collapse: 'צמצם',
	more: 'עוד',
	options: 'אפשרויות',
	editProject: 'ערוך פרוייקט',
	manageTeam: 'ניהול צוות',
	markAsCompleted: 'סמן כהושלם',
	connectedTo: 'מחובר ל-',
	connectedClients: 'לקוחות מחוברים',
	connectedToClients: (count) => `${count} ${count == 1 ? 'client' : 'clients'}`,
	connectedToEngagements: (count) => `Engagements: ${count == 0 ? 'None' : count}`,
	countEngagements: (count) => `${count} ${count === 1 ? 'engagement' : 'engagements'}`,
	connectToEngagements: (count) => `Connect ${count} ${count == 1 ? 'engagement' : 'engagements'}`,
	connectedToAccessGroups: (count) => `Connected to ${count} ${count == 1 ? 'group' : 'groups'}`,
	connectToAccessGroups: (count) => `Connect ${count} ${count == 1 ? 'group' : 'groups'}`,
	entitiesLabelForCount: (count) => `${count} ${count == 1 ? 'Entity' : 'Entities'}`,
	viewsLabelForCount: (count) => `${count} ${count == 1 ? 'View' : 'Views'}`,
	domainsLabelForCount: (count) => `${count} ${count == 1 ? 'Domain' : 'Domains'}`,
	viewsLabelWithoutCount: (count) => `${count == 1 ? 'View' : 'Views'}`,
	domainsLabelWithoutCount: (count) => `${count == 1 ? 'Domain' : 'Domains'}`,
	engagement: 'תיק ביקורת',
	engagementNameLabel: 'שם ההתקשרות',
	engagementPartnerLabel: 'השותף האחראי על תיק הביקורת',
	partnerLabel: 'שותף',
	notInvited: 'לא מוזמן',
	clientNameLabel: 'שם הלקוח',
	client: 'לקוחות',
	codeLabel: 'קוד',
	idLabel: 'ID',
	engagements: 'תיקי הביקורת',
	engagementsLabel: 'תיקי הביקורת',
	noResultsFound: 'לא נמצאו תוצאות',
	submit: 'שלח',
	saveAndContinue: 'שמור והמשך',
	savecontinue: 'שמור והמשך',
	saveDraft: 'שמור כטיוטה',
	closeLabel: 'Close',
	step1: 'שלב 1',
	step2: 'שלב 2',
	step3: 'שלב 3',
	step4: 'שלב 4',
	step5: 'שלב 5',
	adminsNoneLabel: 'אף אחד',
	domainsAllLabel: 'הכול',
	adminsHeaderLabel: 'מנהלי מערכת:',
	domainsHeaderLabel: 'דומיינים (Domains):',
	moreCountLabel: '+ {0}',
	selectClient: 'בחר לקוח',
	createOrgChart: 'צור תרשים אירגוני',
	connnectToCanvas: 'התחבר ל- EY Canvas',
	viewSummary: 'הצג סיכום',
	viewLabel: 'הצג',
	cancelLabel: 'בטל',
	required: 'נדרש',
	filter: 'סנן',
	filtersWarningMessage: 'חרגת ממגבלת המסנן. ניתן להחיל רק 25 מסננים בבת אחת.',
	back: 'חזור',
	save: 'שמור',
	saveClose: 'שמור וסגור',
	continue: 'המשך',
	finish: 'סיים',
	saveChanges: 'שמור שינויים',
	projectName: 'שם הפרוייקט',
	projectOwners: 'אחראיי הפרויקט',
	addAnotherProjectOwner: 'הוסף אחראי נוסף לפרויקט',
	duplicateOwnerAdded: 'שכפול משתמש',
	step1InstructionHeader: 'הזן שם לפרויקט שלך הוסף אחראיים נוספים לפרויקט ובחר לקוח אחד או יותר מהרשימה למטה כדי להתחיל.',
	step1SubInstructionPart1: `עליך להיות בעל גישה לקודי GIS, GFIS או Mercury של הלקוח או ל-EY Canvas התקשרות כדי לראות את שם הלקוח למטה. הלקוחות שתבחר בשלב זה יקבעו אילו התקשרויות EY Canvas זמינות להתחבר לפרויקט שלך. למידע נוסף על אופן השימוש ב-EY Canvas Oversight, עיין ב-{link} שלנו`,
	step2InstructionHeader: 'צור תרשים ארגוני לפרוייקט שלך',
	step2SubInstructionPart1: 'התרשים הארגוני צריך לשקף את האופן שבו הלקוח שלך מנהל את העסק שלו. הוא ישמש לסיכום נתונים עבור ההתקשרויות של EY Canvas שאתה מחבר לפרויקט שלך ולניהול גישה לחברי צוות פנימיים וחיצוניים.',
	here: 'כאן',
	zoomIn: 'להגדיל את התצוגה (Zoom In)',
	zoomOut: 'להקטין את התצוגה (Zoom Out)',
	expandAll: 'הרחב הכל',
	collapseAll: 'צמצם הכל',
	addLabel: 'הוסף',
	editLabel: 'ערוך',
	removeLabel: 'הסר',
	noRowsTemplateStringPart1: 'אין לך גישה לאף אחד מהלקוחות. לחץ',
	noRowsTemplateStringPart2: 'למידע נוסף על אפן קבלת גישה',
	noRowSelected: 'בחר לקוח אחד לפחות על מנת להמשיך',
	firstName: 'שם פרטי',
	lastName: 'שם משפחה',
	displayLanguage: 'שפת התצוגה',
	numberFormat: 'תבנית מספרית',
	dateFormat: 'תבנית תאריך',
	timezone: 'איזור זמן',
	theme: 'נושא',
	chooseDisplayTheme: 'בחר ערכת נושא לתצוגה כברירת מחדל.',
	light: 'בהיר',
	dark: 'כהה',
	usersettings: 'הגדרות משתמש',
	userOptions: 'אפשרויות משתמש',
	clearHoverText: 'Clear',
	noFiltersAvailable: 'אין מסננים (filters) זמינים',
	dashboard: 'Dashboard',
	milestones: 'סיכום CRA',
	activityFeed: 'הזן פעילות',
	keyEvents: 'אירועי מפתח',
	keyEventCompletion: 'השלמת אירוע מרכזי (Key event)',
	canvasClientPortal: 'Canvas Client Portal',
	canvasClientPortalEy: 'EY Canvas Client Portal',
	groupAudit: 'ביקורת של קבוצה',
	projectManagement: 'ניהול פרויקטים',
	reporting: 'דיווחים',
	insights: 'תובנות',
	groupRiskAssessment: 'הערכת סיכונים קבוצתית',
	internal: 'פנימי',
	external: 'חיצוני',
	members: 'חברי צוות',
	show: 'הצג',
	showDetails: 'הצג פרטים',
	showMore: 'הצג עוד',
	showLess: 'הצג פחות',
	clientName: 'שם הלקוח',
	clientsLabel: 'לקוחות',
	clientLabel: 'לקוח',
	source: 'מקור',
	code: 'קוד',
	accessDelegatedBy: 'גישה שהוקצתה על ידי',
	returnToPreviousStep: 'חזרה לשלב קודם',
	backButtonWarning: 'אם תחזור לשלב קודם ותבצע שינויים, ההתקדמות שלך בשלב זה עשויה להיות מושפעת.<br> בחר <b>המשך</b> כדי לחזור לשלב הקודם או <b>ביטול</b> כדי להישאר ב- שלב זה.',
	step1SubInstructionPart3: 'הלקוחות שתבחר בשלב זה יקבעו אילו התקשרויות ב- EY Canvas זמינים לחיבור הפרוייקט שלך.',
	step3InstructionHeader: 'בחר התקשרות ב- EY Canvas אחד או יותר ולאחר מכן גרור ושחרר אותם בתרשים האירגוני שלך.',
	step3InstructionPara: 'הקשר בין תיקי ביקורת EY Canvas לישויות בתרשים האירגוני שלך קובע קובע כיצד נתוני EY Canvas מסוכמים בדף הראשי (Dashboard) לפרוייקט שלך.',
	availableLabel: 'זמין',
	connectedLabel: 'מחובר',
	milestoneSummaryView: 'אבן דרך (Milestone) - תצוגת סיכום',
	taskCompletionByMilestone: 'השלמת המשימה לפי אבן דרך (milestone)',
	basedOnTaskCompletition: 'מבוסס על השלמת המשימה',
	scopeAndStrategy: 'היקף ואסטרטגיה',
	execution: 'ביצוע הביקורת',
	conclusion: 'מסקנה',
	step3ListDefaultMessage: 'אין תיקי ביקורת זמינים עבור הלקוח(ות) שבחרת בשלב 1. חזור לשלב 1 ובחר לקוח אחר על מנת להמשיך.',
	addNewEngagementLabel: 'הוסף תיק ביקורת חדש',
	selectedLabel: 'המשתמש שנבחר',
	moreText: 'עוד',
	connectLabel: 'התחבר',
	connectEngagements: 'תיקי ביקורת מקושרים',
	connectToAnEngagement: 'קשר תיק ביקורת על מנת להתחיל',
	connectToAnAccessGroup: 'לא קושרו קבוצות.',
	tasks: 'משימות',
	organizationalChartHeading: 'ישויות',
	groupAdministratorsLabel: 'מנהלי קבוצות',
	step4InstructionHeader: 'צור קבוצות לפרויקט שלך וחבר אותן לישות אחת או יותר בתרשים הארגוני שלך.',
	step4ImportantNote: 'Important note: Members of a group can view EY Canvas engagement data for the organizational chart entities that you connect the group to and any children of those entities. If you connect a group to a parent entity on your organizational chart, the group will be able to view EY Canvas engagement data for the parent entity and all of its children.',
	addAGroup: 'הוספת קבוצה',
	addGroup: 'הוסף קבוצה',
	searchGroup: 'חפש קבוצות',
	addNewGroupHeader: 'צור קבוצה חדשה כאן.',
	editNewGroupHeader: 'ערוך קבוצה קיימת כאן.',
	addNewGroupInstruction: 'לאחר יצירת הפרויקט שלך, תוכל להזמין חברי צוות פנימיים וחיצוניים לקבוצה זו. יש לך אפשרות להוסיף מנהל קבוצה שיכול להזמין גם חברים לקבוצה זו.',
	groupName: 'שם הקבוצה',
	groupAdministrators: 'מנהלי קובצות (אופציונלי)',
	groupAdministratorsSubHeading: 'הוסף מנהל לקבוצה. מנהלי קבוצות יכולים להזמין חברי צוות לפרויקט שלך לאחר יצירת הקבוצה. הם לא יכולים לערוך את התצוגות והדומיינים (domains) לקבוצה זו.',
	clearAllValues: 'Clear',
	createGroupDashboardViews: 'תצוגות דף ראשי (Dashboard)',
	dashboardViewsSubHeading: 'בחר תצוגה אחת לפחות. הנ"ל קובע את הנתונים שחברים יכולים לראות כאשר הם רואים את הדף הראשי (Dashboard) של הפרויקט שלך.',
	duplicateDomain: 'שכפול דומיין (domain)',
	allMilestones: 'כל אבני הדרך (Milestones)',
	someMilestonesSelected: 'נבחרו {0} אבני דרך',
	noGroupsAdded: 'לא נוספו דומיינים (domains) לפרוייקט זה',
	step5InstructionHeader: 'סקור את פרויקט EY Canvas Oversight שלך.',
	step5SubInstruction: 'אם עליך לבצע שינויים, בחר בעיפרון ערוך כדי לחזור לשלב מוקדם יותר. <b>ביצוע שינויים בשלב מוקדם יותר עשוי להשפיע על ההתקדמות בשלבים מאוחרים יותר.</b>',
	associationNotRequired: 'אין צורך בשיוך',
	accessGroupAlreadyAddedToParent: 'כבר קישרת אחת או יותר מהקבוצות שנבחרו לישות אב. אם קבוצת גישה מחוברת לישות אב, חבריה יכולים לצפות בנתוני ההתקשרות EY Canvas עבור ישות האב וכל צאצאיה. לכן, שיוך אינו נדרש.',
	deleteGroupInstructionalText: 'האם אתה בטוח שברצונך למחוק קבוצה זו? <br>למחיקה, אין אפשרות לבטל את הפעולה. חברי הקבוצה לא יוכלו עוד לגשת לפרוייקט שלך.',
	deleteGroup: 'מחק קבוצה',
	removeMember: 'הסר חבר צוות',
	removeMemberTitle: 'האם אתה בטוח שברצונך להסיר חבר צוות זה? אם החבר שייך למספר קבוצות, הם יוסרו מכל הקבוצות המפורטות כאן וייתכן שלא יוכלו יותר לגשת לפרויקט זה. אם אתה רק רוצה להסיר את החבר מקבוצה אחת, בחר במקום זאת באפשרות <b> ערוך </b>.',
	teamMember: 'חבר צוות',
	clientNameLbl: 'לקוחות',
	help: 'עזרה',

	//Org char left rail
	filters: 'מסננים',
	countEngagementSelected: '{0} מתוך {1} תיקי ביקורת נבחרו',
	of: '{num} מתוך',
	entityName: 'שם הישות',
	enterEntityName: 'הזן שם כאן',
	projectOwner: 'אחראי הפרויקט (Project owner)',
	role: 'Role',
	domains: 'דומיינים (אופציונלי)',
	domainSubHeading: 'הוסף לפחות דומיין אחד אם חברי צוות חיצוניים יוזמנו לקבוצה זו. דומיין מתייחס לתווים שאחרי הסימן @ בכתובת דואר אלקטרוני. כדי להוסיף חבר צוות חיצוני, עליו להיות בעל דומיין חוקי עבור הקבוצה הזו.',
	addAdministrator: 'הוספת מנהל קבוצה',
	addNewDomain: 'הוספת דומיין (domain) חדש',
	addExistingDomain: 'הוסף דומיין (domain) קיים',
	placeholderStep3NoEngagementMessage: 'אין תיקי ביקורת זמינים עבור הלקוח(ות) שבחרת בשלב 1. חזור לשלב 1 ובחר לקוח אחר על מנת להמשיך.',
	placeholderStep3NoConnectedEngagementMessage: 'עדיין אין תיקי ביקורת מקושרים',
	placeholderStep3AllEngagementsConnected: 'כל ההתקשרויות הזמינות מחוברות לפרויקט שלך.',
	placeholderStep4NoConnectedGroupMessage: 'אין עדיין קבוצות מקושרות.',
	domainName: 'שם דומיין (domain)',
	engagementLabel: 'תיק ביקורת',
	start: 'להתחיל',
	end: 'סוף',
	suggestedEnd: 'סיום מוצע',
	status: 'סטטוס',
	thereIsNoDataToDisplay: 'אין נתונים להצגה',
	selectadditionalEntitiesToContinue: 'בחר ישויות נוספות על מנת להמשיך',
	comingSoonToDisplay: 'סטטוס הישות המוחזקת יהיה זמין בקרוב.',
	checkForUpdatesToDisplay: 'בדוק שוב בשבועות הקרובים לקבלת עדכונים.',
	userSearchPlaceholder: 'הזן שם או דוא"ל ולחץ Enter כדי לראות תוצאות.',
	userSearchPlaceholderForExternal: 'הזן דוא"ל ולחץ Enter כדי לראות תוצאות.',
	partnerInChargeInvitedToTheEngagement: 'שותף הביקורת האחראי הוזמן לתיק הביקורת',
	partnerInChargeSignedOffOnCraSummary: 'השותף האחראי על תיק הביקורת חתם על סיכום הערכת הסיכון המשולב (CRA)',
	eqrSignedOffOnCraSummary: 'ה- EQR חתם על סיכום הערכת הסיכון המשולב (CRA)',
	partnerInChargeSignedOffOnAuditPlan: 'הושתף האחראי על הביקורת חתם על תוכנית הביקורת',
	picInvited: 'השותף האחראי על הביקורת (PIC) הוזמן',
	picSignOffCRA: 'השותף האחראי על הביקורת (PIC) חתם על CRA',
	picSignOffAuditPlan: 'השותף האחראי על הביקורת (PIC) חתם על תוכנית הביקורת (Audit Plan)',
	eqrSingOffCRA: 'השותף המלווה (EQR) חתם על ה- CRA',
	overdue: 'תאריך היעד חלף',
	outOf: 'מתוך',
	edit: 'ערוך',
	remove: 'הסר',
	add: 'הוסף',
	admin: 'מנהלים אדמרניסטטיביים',
	views: 'תצוגות דף ראשי (Dashboard)',
	domainLabel: 'דומיין (domain)',
	domainslabel: 'דומיינים (domains)',
	viewLabelText: 'הצג',
	viewsLabelText: 'תצוגות דף ראשי (Dashboard)',
	administrators: 'מנהלי מערכת',
	none: 'אף אחד',
	organizationChart: 'תרשים ארגוני',
	invalidDomainName: 'שם דומיין לא חוקי',
	lastRefreshed: 'רענון אחרון',
	lastRefreshedActivityFeed: 'Activity feed data last refreshed',
	lastRefreshedReconciliation: 'התאמת הנתונים האחרונה שעודכנה',
	quickFilter: 'מסנן מהיר',
	notApplied: 'לא מיושם',
	quickFilterInput: 'שם מסנן מהיר',
	quickFilterSubHeaderText: 'כשתסיים, תוכל ליישם את המסנן המהיר כדי לחדד את הישויות שעבורן תרצה להציג נתונים מבלי שתצטרך לבחור כל אחת בנפרד.',
	createFilterTrigger: 'צור מסנן חדש',
	createFilterTitle: 'צור מסנן מהיר חדש',
	createFilterButton: 'צור מסנן מהיר',
	createFilterHeaderText: 'בחר ישות אחת או יותר מהתרשים הארגוני ליצירת מסנן מהיר.',
	createFilterSubHeaderText: 'כשתסיים, תוכל ליישם את המסנן המהיר כדי לחדד את הישויות שעבורן תרצה להציג נתונים מבלי שתצטרך לבחור כל אחת בנפרד.',
	editFilterTitle: 'ערוך מסנן מהיר',
	editFilterHeaderText: 'ערוך או מחק מסנן מהיר.',
	editFilterIconTitleTip: 'ערוך',
	oneRequired: 'נדרשת בחירה אחת לפחות.',
	noFiltersCreatedTitle: 'עדיין לא נוצרו מסננים מהירים.',
	noFiltersCreatedSubTitle: 'צור מסנן מהיר להתחלת העבודה.',
	clear: 'Clear',
	completionRange: 'טווח השלמה',
	engagementCount: 'מספר התקשרות',
	clickOnAVisualBelowToFilterTheEngagementList: 'לחץ על התצוגה מטה בכדי לסנן את רשימת תיקי הביקורת.',
	organizationalChartTooltip: 'בחר תרשים ארגוני לעריכה או הסרת ישויות מפרויקט ה- Oversight שלך.',
	organizationalChart: 'תרשים ארגוני',

	//Task status chart labels
	open: 'פתח',
	inProgress: 'בתהליך',
	inReview: 'בסקירה',
	completeUpperCase: 'המשימות למענה  בביקורת הושלמו',
	taskStatusOverdue: 'תאריך היעד חלף',
	noDataForSelections: 'אין נתונים זמינים לבחירות שלך',
	selectOneOrMoreMilestones: 'בחר אבני דרך (milestones) שונות אחת או יותר על מנת להמשיך',
	milestoneDetailTitle: 'אבני דרך (Milestones) - פירוט',
	taskStatusByMilestone: 'סטטוס המשימה לפי אבן דרך (milestone)',
	milestoneDetailSubtitle: 'בהתבסס על סטטוס המשימה',
	basedOnAllTasksForTheSelectedMilestone: 'מבוסס על כל המשימות עבור אבני הדרך (milestones) הנבחרים',
	totalTasks: 'סה"כ משימות',
	noneSelected: 'לא נבחר כלום',
	nameOrEmail: 'שם או דוא"ל',
	remove: 'הסר',
	milestonesTooltipText: 'התקדמות הביקורת לפי אבן דרך (milestones)',
	canvasClientPortalTooltipText: 'סטטוס הבקשה, לרבות תאריך היעד, פריטים שתאריך היעד שלהם חלף ופריטים שהוחזרו',
	groudAuditTooltipText: 'סטטוס צוות ביקורת ראשי ושל ישויות מוחזקות, לרבות כאלו שתאריך היעד שלהם חלף',
	projectManagementTooltipText: 'סטטוס הערות סקירה והקצאות, לרבות פריטים באיחור. תצוגה זו לא תהיה גלויה ללקוחות.',
	insightsTootipText: 'השוואת סיכונים, נהלים מהותיים, אסטרטגיית בקרה וממצאים בין צוותים ראשוניים ומרכיבים. תצוגה זו לא תהיה גלויה ללקוחות.',
	reportTootipText: 'דווח על מוכנות, שינוי וסטטוס השלמת משימה לפי מדינה',
	taskStatusComplete: 'סטטוס המשימה - הושלם',
	taskStatusInreview: 'סטטוס המשימה - בסקירה',
	taskStatusInprogress: 'סטטוס המשימה - בתהליך עבודה',
	taskStatusOpen: 'סטטוס המשימה - פתוח',

	//Review Notes chart labels
	reviewNotesByStatusTitle: 'כל הערות הסקירה (review notes)',
	byStatus: 'לפי סטטוס',
	totalNotes: 'סה"כ הערות',
	totalNotesLabel: 'סה"כ הערות',
	openNotes: 'הערות פתוחות',
	byPriority: 'לפי עדיפות',
	cleared: 'Cleared',
	closed: 'סגור',
	low: 'Low',
	medium: 'Medium',
	high: 'High',
	critical: 'Critical',
	notesTableTooltipContent: "מבוסס על הערות סקירה עם סטטוס 'פתוח'",

	// Group audit
	groupAuditTotalForms: 'סך כל הטפסים',
	groupAuditNotSent: 'לא נשלח',
	groupAuditUnlinked: 'לא מקושר',
	totalTasksCapitalized: 'סה"כ משימות',
	primary: 'צוות ראשי',
	component: 'ישות מוחזקת (component)',

	//Bar chart
	are: 'הם',
	complete: 'המשימות למענה  בביקורת הושלמו',
	noMilestoneDataForSelection: 'אין נתוני אבן דרך (milestone) להצגה בלשלב הזה בביקורת.',
	selectDifferentAuditPhase: 'בחר שלב ביקורת (audit phase) אחר או בחר ישויות נוספות על מנת להמשיך',

	//Delegate
	delegateInstruction: "האצל גישה לחבר הצוות האחר שלך כדי שיוכל ליצור פרויקטים בשמך. הזן שם או כתובת אימייל של חבר צוות כדי להתחיל. לנציגים שלך תהיה גישה לכל הלקוחות שלך.",

	delegateAccess: 'נהל מיופי כוח',
	addAnother: 'הוסף מיופי כוח',
	hideMyDelegate: 'הסתר את מיופי הכוח שלי',
	showMyDelegate: 'הצג את מיופי הכוח שלי',
	noRecord: 'לא נמצאו תוצאות',
	duplicateUser: 'מיופה כוח כבר נוסף',
	duplicateUserMessage: 'המשתמש כבר נוסף',
	addDelegates: 'הוסף מיופי כוח',
	delegateTo: 'הוקצה ל',
	delegateFrom: 'הוקצה על ידי',
	delegateToMsg: 'לא הקצת את הגישה שלך לאף אחד מחברי הצוות.',
	delegateFromMsg: 'אף אחד מחברי הצוות לא הקצה לך גישה.',

	// Project dashboard left rail
	searchFilterPlaceholder: 'מסנני חיפוש',
	searchEntitiesPlaceholder: 'חפש ישויות',
	outOfEngagements: '<b> {0} </b> מתוך <b> {1} </ b> תיקי ביקורת',
	engagementCompletedBasedOnTaskCompletion: '<b> {0} </b> תיק ביקורת <b> {1} </b> הושלם בהתבסס על השלמת המשימה',
	engagementsCompletedBasedOnTaskCompletion: '<b> {0} </b> התקשרויות הושלמו <b> {1} </b> בהתבסס על השלמת המשימה',
	engagementCompletedBasedOnTaskCompletionReporting: 'התקשרות  <b> {0} </b> השלימה את <b> {1} </b> המשימות',
	engagementsCompletedBasedOnTaskCompletionReporting: '<b> {0} </b> התקשרויות השלימו את <b> {1} </b> המשימות',
	engagementCompletedBasedOnTaskCompletionMilestone: 'התקשרות <b> {0} </b> השלימה את <b> {1} </b> המשימות לאבן דרך (milestone) זו',
	engagementsCompletedBasedOnTaskCompletionMilestone: '<b> {0} </b> התקשרויות השלימו <b> {1} </b> משימות לאבן דרך זו',
	reportReleaseDate: 'תאריך הפצת הדוח',
	partnerInvited: 'שותף מוזמן',
	picSignoffOnCra: 'חתימה של PIC על הערכת הסיכון המשולב (CRA)',
	eqrSignoffOnCra: 'חתימת EQR על הערכת הסיכון המשולב (CRA)',
	picSignoffOnAuditPlan: 'חתימת PIC על תוכנית הביקורת',
	overdueLabel: 'תאריך היעד חלף',

	//Team members
	teamMembersTitle: 'חברי הצוות',
	membersTitle: 'חברי צוות',
	eyContactsTitle: 'אנשי קשר של EY',
	allMembersLabel: 'כל חברי הצוות',
	internalMembersLabel: 'חברי צוות פנימיים',
	externalMembersLabel: 'חברי צוות חיצוניים',
	groupsTitle: 'הקבוצות שלי',
	projectOwnersTitle: 'אחראיי הפרויקט',
	projectOwnersLabel: 'אחראיי הפרויקט',
	projectOwnerLabel: 'אחראי הפרויקט (Project owner)',

	//CCP
	summary: 'סיכום',
	requestsByStatus: 'בקשות לפי סטטוס',
	totalRequests: 'סך הבקשות',
	totalRequestsTitle: 'סך הבקשות',
	receivedByEy: 'התקבל על ידי EY',
	acceptedByEy: 'התקבל על ידי EY',
	outstandingByEy: 'יוצא מן הכלל (outstanding)',
	returned: 'הוחזר',
	receivedByEyOnTime: 'התקבל על-ידי EY בזמן',
	averageDaysOverdue: 'ממוצע ימים באיחור',
	outOfReceivedAndAccepted: '<b>{0}</b> מתוך  <b>{1}</b> בקשות שהתקבלו והתקבלו',
	outOfStandingRequests: '<b>{0}</b> מתוך <b>{1}</b> בקשות בטיפול',
	outOfAverageDaysOverdue: '<b>{0}</b> מתוך <b>{1}</b> בקשות בטיפול',
	draftRequests: '{0} בקשות טיוטה',
	noResultMessageHeader: 'אין נתונים להצגה. בחר ישויות נוספות על מנת להמשיך.',
	noResultMessageSubHeader: '',
	members: 'חברי צוות',
	memberLabel: 'חבר',
	adminLabel: 'Admin',
	projectOwnerLabel: 'אחראי הפרויקט (Project owner)',
	viewsLabel: 'תצוגות דף ראשי (Dashboard)',
	metrics: 'מדדים',
	yes: 'כן',
	no: 'לא',
	emptyMessageAvailableGroup: 'עדיין לא נוצרו קבוצות. <br>בחר <b>הוספת קבוצה</b> לתחילת העבודה.',
	thereIsNoDataToDisplayForThisEntity: 'אין נתונים להצגה עבור ישות זו.',
	typeLabel: 'סוג',
	groupsLabel: 'קבוצות',
	group: 'קבוצה',
	entitiesLabels: 'ישויות',
	entityLabel: 'ישות',
	nameLabel: 'שם',
	searchTeamMembers: 'חפש חברי צוות',
	notSelectedLabel: 'לא נבחר',
	entitiesLabel: 'ישויות',
	noDataAvailableLabel: 'אין נתונים זמינים.',
	delete: 'מחק',
	deleted: 'נמחק',
	addAMember: 'הוספת חבר צוות',
	addMemberHeaderText: 'הוסף חבר צוות חדש לקבוצה אחת או יותר עבור הפרוייקט שלך.',
	teamMemberInformation: 'מידע אודות חברי הצוות',
	teamMemberNote: 'הזן את השם או הדואר האלקטרוני עבור חבר הצוות הפנימי או החיצוני שברצונך להוסיף לקבוצות שנבחרו. הקש על מקש Enter כדי לראות תוצאות.',
	selectGroupNote: 'בחר לפחות קבוצה אחת. חברי הקבוצה יכולים לצפות בנתוני תיק הביקורת ב EY Canvas עבור כל הישויות בתרשים הארגוני שהקבוצות שלהם מחוברות אליהן, כמו גם עבור צאצאים של ישויות אלה.',
	inviteAndClose: 'הזמן וסגור',
	inviteAndAddAnother: 'הזמן והוסף נוסף',
	contacts: 'אנשי קשר',
	email: 'אי-מייל',
	emailAll: 'שלח הכל בדואר אלקטרוני',
	contactTeam: 'צוות קשר',
	emptyMessage: 'אין אנשי קשר זמינים עבור תיק ביקורת זה.',
	comingDue: 'לקראת תאריך היעד',
	tomorrow: 'מחר',
	next3days: '3 הימים הבאים',
	next5days: '5 הימים הבאים',
	next10days: '10 הימים הבאים',
	next30days: '30 הימים הבאים',
	comingDueNext5days: 'תאריך היעד בעוד (5 הימים הקרובים)',
	entityDetails: 'פרטי הישות',
	requestsByEntity: 'בקשות של ישות',
	basedOnTheSelectedCategory: 'מבוסס על הקטגוריה שנבחרה',
	requestCount: 'מספר הבקשות',
	selectedDay: 'יום נבחר',
	editMember: 'ערוך חבר צוות',
	editMemberHeaderText: 'ערוך את הקבוצות שלחבר הצוות שנבחר יש גישה אליהן.',
	editaGroup: 'ערוך קבוצה',
	editAGroupHere: 'ערוך קבוצה כאן',
	selectAnotherFrame: 'בחר מסגרת זמן אחרת להצגת נתונים.',
	emptyFrameShort: 'בחר ישויות נוספות על מנת להמשיך',
	emptyFrame: 'בחר ישויות נוספות או מסגרת זמן אחרת כדי להמשיך.',
	editMemberHeaderText: 'ערוך את הקבוצות שלחבר הצוות שנבחר יש גישה אליהן.',
	confirm: 'אשר',
	markCompleteModalInstrTextPart1: 'האם אתה בטוח שברצונך להשלים פרוייקט זה?',
	markCompleteModalInstrTextPart2: 'לאחר שתבצע פעולה זו, לא ניתן יהיה לבטל אותה. ניתן לגלגל קדימה פרוייקטים שהושלמו  ולהשתמש בהם כתבנית בעת יצירת פרוייקט חדש.',
	firstPage: 'הדף הראשון',
	lastPage: 'הדף האחרון',
	nextPage: 'הדף הבא',
	prevPage: 'הדף הקודם',

	// Add Tag
	keyContacts: 'אנשי קשר מרכזיים',
	customTags: 'תגים מותאמים אישית',

	// Manage Tags
	manageTagInstructional: 'צור תגים מותאמים אישית חדשים כאן. אתה יכול גם לערוך ולמחוק תגים מותאמים אישית קיימים. תיוג אנשי קשר נותן לך את הגמישות לנהל אנשי קשר בפרויקט EY Canvas Oversight שלך.',
	emptyCustomTagsList: 'עדיין לא נוצרו תגים מותאמים אישית.',
	manageTagTitle: 'נהל תגים מותאמים אישית',
	manageTagLinkButton: 'נהל תגים',
	color: 'צבע',
	tagName: 'שם',
	tagDelete: 'מחק',
	tagCreate: 'צור תג חדש',
	customTagsHeader: 'תגים מותאמים אישית',

	//preparer assignment tile
	totalPreparerAssignments: 'סך הקצאות מכין',
	inprogress: 'מתבצע',
	preparerAssignments: 'הקצאות מכין',
	byAssignmentStatus: 'סטטוס לפי הקצאה',
	taskWithoutPreparerAssignments: 'משימה  ללא הקצאת מכין',
	tasksWithoutPreparerAssignments: 'משימות  ללא הקצאות מכין',
	preparerFilterTitle: 'מכין',

	// reviewer assignment tile
	totalReviewerAssignments: 'סך מטלות הבודקים',
	taskWithoutReviewerAssignments: 'משימה  ללא הקצאת סוקר',
	tasksWithoutReviewerAssignments: 'משימות  ללא הקצאות סוקרים',
	reviewerFilterTitle: 'סוקר',

	assignments: 'משימות לביצוע',
	notes: 'הערות',
	preparerNotAssigned: 'לא הוקצה מכין',
	reviewerAssignments: 'הקצאות לסוקר',
	reviewerNotAssigned: 'לא הוקצה סוקר',
	basedOnPreparerAssignments: 'בהתבסס על הקצאות מכין',
	basedOnPreparerAssignmentsOpenAndInProgress: "בהתבסס על הקצאות מכין עם סטטוס 'פתוח' ו'בתהליך'",
	basedOnReviewerAssignments: 'בהתבסס על הקצאות סוקר',
	basedOnReviewerAssignmentsOpenAndInProgress: "בהתבסס על הקצאות סוקר עם סטטוס 'פתוח' ו'בתהליך'",

	statusOpen: 'סטטוס - פתוח',
	statusInProgress: 'סטטוס - בתהליך עבודה',
	statusClosed: 'סטטוס - סגור',
	byPriorityLow: 'לפי עדיפות - נמוך',
	byPriotityMedium: 'לפי עדיפות - בינוני',
	byPriorityHigh: 'לפי עדיפות - גבוה',
	byPriorityCritical: 'לפי עדיפות - קריטי',

	findingsLabel: 'ממצאים',
	riskLabel: 'סיכונים',
	digitalAuditLabel: 'ביקורת דיגיטלית',
	digitalAuditStrategy: 'אסטרטגיית ביקורת דיגיטלית',
	byDigitalAuditTypeLabel: 'על ידי אסטרטגיית ביקורת דיגיטלית',
	basedOnProfileSelection: 'מבוסס על בחירת הפרופיל',
	basedOnSelectionArchiveForm: 'מבוסס על בחירה בטופס הארכיב',
	MisstatementsByType: 'הפרשי ביקורת לפי סוג',
	DeficienciesBySeverity: 'ליקויים לפי חומרה',
	MisstatementsLabel: 'הצגות מוטעות',
	DeficienciesLabel: 'ליקויים',
	primarTeamDeficiencyHeader: 'צוותים ראשיים (PT) - {0}',
	componentRegionalTeamDeficiencyHeader: 'צוותים אזוריים (RT) וישויות מדווחות (CT) - {0}',
	auditTileHeaderTextPrimary: 'צוותים ראשיים (PT) - {0}',
	componentRegionalTeamHeader: 'צוותים אזוריים (RT) וישויות מדווחות (CT) - {0}',
	allTeamDeficiencyHeader: 'כל תיקי הביקורת - {0}',
	primarTeamMisstatementHeader: 'צוותים ראשיים (PT) - {0}',
	componentRegionalTeamMisstatementHeader: 'צוותים אזוריים (RT) וישויות מדווחות (CT) - {0}',
	allTeamMisstatementHeader: 'כל תיקי הביקורת - {0}',
	deficiencyLabel: 'ליקוי',
	inherenRisktLabel: 'סיכון להצגה מוטעית מהותית',
	significantRiskLabel: 'משמעותי',
	fraudRiskLabel: 'הונאה',
	significantDeficiencyLabel: 'ליקוי משמעותי',
	materialWeaknessLabel: 'חולשה מהותית',
	factualLabel: 'Factual - עובדתי',
	projectedLabel: 'Projected - מושלך על יתר האוכלוסיה',
	judgmentalLabel: 'Judgmental - שמקורו בשיקול דעת',
	reclassificationLabel: 'Reclassification - בשל סיווג מחדש',
	totalDeficiencyLabel: 'סך ליקוי',
	totalRiskLabel: 'סך סיכון',
	totalRisksLabel: 'סך סיכונים',
	totalDeficienciesLabel: 'סך ליקויי בקרה',
	totalMisstatementLabel: 'סך הפרש ביקורת',
	totalMisstatementsLabel: 'סך הפרשי ביקורת',
	allEngagementHeader: 'כל תיקי הביקורת - {0}',
	noAuditSightGroupData: '<b> אין נתוני ביקורת קבוצה להצגה. </b> <br> בחר <b> הכל </b> מהמתג כדי לראות נתונים מסוכמים.',
	noAuditTileDataPlaceholder: 'אין נתונים להצגה. בחר ישויות נוספות על מנת להמשיך.',
	openReviewNotes: 'פתחו הערות סקירה (review notes)',
	byPriorityLevel: 'לפי עדיפות',
	risks: 'סיכונים',
	groupRoleLabel: 'תפקיד בקבוצה',
	totalRisks: 'סך סיכונים',
	byType: 'לפי סוג',
	inherent: 'סיכון להצגה מוטעית מהותית',
	significant: 'משמעותי',
	fraud: 'הונאה',
	strategy: 'אסטרטגיית תת התהליך המהותי (SCOT)',
	notApplicable: 'לא ישים',
	customizableTable: 'התאם אישית את הטבלה',
	selectUpToOptionHeader: 'בחר עד {0} אפשרויות',
	selectUpToThreeOptionHeader: 'בחר עד שלוש אפשרויות',
	selectUpToFourOptionHeader: 'בחר עד ארבע אפשרויות',
	psps: 'PSPs',
	osps: 'OSPs',
	hxpsps: 'HxPSPs',
	totalSubstantiveProcedures: 'סך כל נהלי הביקורת המבססים',
	totalSubstantiveProcedure: 'סך כל נהלי הביקורת המבססים',
	totalITControls: 'סך ITGCs ו- ITSPs',
	totalITControl: 'סך הכל ITGC ו- ITSP',
	testing: 'בודק',
	nonTesting: 'לא נדגם',
	auditStrategy: 'אסטרטגיית ביקורת',
	totalControls: 'סך בקרות',
	totalControl: 'סך בקרה',
	removeProject: 'הסר את הפרויקט',
	removeProjectInstructionalText: 'האם אתה בטוח שברצונך להסיר את הפרויקט הבא מרשימת הפרויקטים הפעילים שלך? <br>אם תסיר את הפרויקט, לא תוכל יותר לגשת אליו.',
	substantiveProcedures: 'ביקורת מבססת',
	controls: 'בקרות',
	itlabel: 'IT',

	//delegates removed
	userDelTitle: 'מיופי הכוח שלי',
	delTitleDetail: 'העברת את הגישה שלך לחברי הצוות המופיעים כאן. לנציגים שלך יש גישה לכל הלקוחות אליהם יש לך גישה.',
	delElseMsg: 'עדיין לא הוספת מיופה כוח.',
	delegateTitle: 'הסר מיופה כוח',
	delegateMember: 'הוקצה',
	deleteMessage: 'האם אתה בטוח שברצונך להסיר את מיופה הכוח הזה? <br/> לאחר ההסרה, הם כבר לא יוכלו ליצור פרויקטים בשמך.',

	//Advanced filters.
	advancedFilters: 'מסננים מתקדמים',
	selectAll: 'בחר הכל',
	deselectAll: 'בטל את כל הסינונים',
	applyFilters: 'החל מסננים',
	region: 'אזור (region)',
	country: 'מדינה',
	city: 'עיר',
	state: 'מדינה',
	advancedFiltersInstructionalText: 'בחר את הישויות שעבורן תרצה להציג נתוני מעורבות.',
	advancedFiltersInstructionalTextLine2: 'ישויות שאין לך גישה להופיע בהן מושבתות. שוחח עם מנהל ביקורת הקבוצה אם אתה זקוק לגישה.',
	engagementsSelected: 'תיק(י) הביקורת שנבחר(ו)',
	filterYes: 'כן',
	filterNo: 'לא',

	//Group Audit
	pendingResponse: 'ממתין למענה',
	primaryTileTitle: 'סטטוס צוות הביקורת הראשי PT',
	reportingFormStatus: 'סטטוס חבילת הדיווח',
	reportingForm: 'חבילת דיווח',
	summarizedForPrimaryTeams: 'סיכום לצוותי הביקורת הראשיים (primary teams)',
	primaryTileSubtitle: 'נשלחו טפסי דיווח קבוצתיים',
	received: 'התקבל',
	dueToPrimaryTeam: 'בשל צוות הביקורת הראשי PT',
	sentToPrimaryTeam: 'נשלח לצוות הביקורת הראשי',
	evidencePending: 'ראיות ביקורת בהמתנה',
	evidenceComplete: 'ראיות ביקורת שהושלמו',
	componentTileTitle: 'סטטוס צוות ביקורת של ישות מוחזקת CT',
	componentTaskStatus: 'סטטוס משימה לישות מוחזקת',
	componentTask: 'משימה לישות מוחזקת',
	comingsoonTaskStatus: 'בקרוב',
	summarizedForComponentTeams: 'סיכום לצוותי הביקורת של הישויות המוחזקות (Component teams)',
	componentTileSubtitle: 'משימות ביקורת קבוצתיות שהתקבלו',
	unlinkedTask: 'משימה לא מקושרת',
	unlinkedTasks: 'משימות לא מקושרות',

	//Group Risk Assessment
	groupRiskAssessmentTitle: 'סיכונים',
	groupRiskSummaryTitle: 'הערכת סיכונים קבוצתית',

	// Reporting
	reportModifications: 'דווח על שינויים',
	byReportType: 'לפי סוג הדוח',
	notSelected: 'לא נבחר',
	unmodified: 'ללא שינוי',
	modified: 'עבר שינוי',
	reports: 'דיווחים',
	opinions: 'חוות דעת',
	modifiedReports: 'דיווחים שהשתנו',
	modifiedOpinions: 'חוות דעת מסויגת',
	adverse: 'שְׁלִילִי',
	disclaimer: 'המנעות',
	qualification: 'בנוסח האחיד',
	qualified: 'חוות דעת שאינה בנוסח האחיד',
	engagementReportTooltip: 'רק תיקי ביקורת עם תאריכי דיווח בתאריך הנוכחי או לפניו מסוכמים כאן. כל תיקי הביקורת מוצגים בטבלה שלהלן.',
	geography: 'גֵאוֹגרַפי',
	standars: 'תקנים',
	gaap: 'GAAP',
	gaapUs: 'GAAP US',
	ifrs: 'Other Transportation – Local and Urban Transportation',
	other: 'אחרים',
	yearEndDate: 'תאריך סוף שנה',
	endDateOfPeriodCovered: 'תאריך סיום של התקופה המבוקרת/נסקרת',
	reportDate: 'תאריך הדוח',
	archiveDeadline: 'מועד אחרון לארכיב',
	reportType: 'סוג הדוח',
	opinionType: 'סוג חוות דעת',
	taskStatus: 'סטטוס המשימה',
	exportData: 'ייצוא נתונים',
	exportToExcel: 'ייצא',
	orgChartEntity: 'ישות בתרשים הארגוני',
	engagementId: 'מזהה תיק הביקורת',
	contactName: 'שם איש קשר',
	contactEmail: 'דוא"ל ליצירת קשר',
	statusInherent: 'By Type - Risk of material misstatement',
	statusSignificant: 'לפי סוג - משמעותי (Significant)',
	statusFraud: 'לפי סוג - מעילה (Fraud)',
	substantivePSPs: 'מבסס - PSPs',
	substantiveOSPs: 'מבסס - OSPs',
	substantiveHxPSPs: 'מבסס - HxPSPs',
	controlsTesting: 'בקרות - דגימות',
	controlsNonTesting: 'בקרות - ללא דגימות',
	iTTesting: 'IT - דגימות',
	iTNonTesting: 'IT - ללא דגימות',
	misstatementsFactual: 'הצגות מוטעות - עובדתיות (Factual)',
	misstatementsProjected: 'הצגות מוטעות - מושלך על יתר האוכלוסייה (Projected)',
	misstatementsJudgmental: 'הצגות מוטעות - שמקורן בשיקול דעת (Judgmental)',
	misstatementsReclassification: 'הצגות מוטעות - שמקורן בסיווג מחדש (Reclassification)',
	deficienciesDeficiency: 'ליקויים - ליקוי',
	deficienciesSignificantdeficiency: 'ליקויים - ליקוי משמעותי',
	deficienciesMaterialweakness: 'ליקויים - חולשה מהותית',
	statusComplete: 'סטטוס - הושלם',
	statusInReview: 'סטטוס - בסקירה',
	statusInProgress: 'סטטוס - בתהליך עבודה',
	statusOpen: 'סטטוס - פתוח',
	statusNotSent: 'סטטוס - לא נשלח',
	statusReturned: 'סטטוס - הוחזר',
	statusDocumentationPending: 'סטטוס - תיעוד בהמתנה',
	statusDocumentationComplete: 'סטטוס - התיעוד הושלם',
	statusReceivedbyEY: 'סטטוס - התקבל על ידי EY',
	statusAcceptedbyEY: 'סטטוס - אושר על ידי EY',
	statusOutstanding: 'סטטוס - בהמתנה',
	noCompletedProjectsMessagePart1: 'אין לך פרויקטים שהושלמו.',
	noCompletedProjectsMessagePart2: "אם אתה בעל הפרויקט, תוכל לסמן את הפרויקט כ'הושלם'. ניתן לגלגל קדימה פרויקטים שהושלמו ולהשתמש בהם כתבנית בעת יצירת פרויקט חדש.",
	noCompletedProjectsMessage: 'אין לך פרויקטים שהושלמו. <br>אם אתה בעל פרויקט, אתה יכול לסמן שהפרויקט הושלם. ניתן לגלגל פרויקטים שהושלמו קדימה ולהשתמש בהם כתבנית בעת יצירת פרויקט חדש.',
	requests: 'בקשות',

	//Reporting readiness report
	week: 'שָׁבוּעַ',
	weeks: 'שבועות',
	readinessReportTitle: 'דיווח על מוכנות',
	taskCompletionByEngagement: 'השלמת המשימה לפי התקשרות',
	readinessLegendTitle: 'בסמיכות לתאריך הדיווח',
	basedOnReportDateProximityForEachEngagement: 'בהתבסס על סמיכות תאריך הדוח לכל התקשרות',

	//ReportCompletion
	taskCompletionStatus: 'סטטוס השלמת המשימות',
	taskCompletionByLocation: 'השלמת המשימות לפי מיקום',
	basedOnCompletedTasksForEachEngagement: 'מבוסס על משימות שהושלמו עבור כל התקשרות',
	byGeography: 'לפי אזור גיאוגרפי',
	taskCompletion: 'השלמת משימה',
	completedTasks: 'משימות שהושלמו',

	engagementArchived: 'התקשרות זו הועברה לארכיון. הנתונים אינם זמינים יותר.',
	externalUsersNoActiveProjMessage: 'אין לך פרויקטים פעילים. שוחח עם חבר צוות EY כדי לקבל גישה.',

	//Error Messages
	networkErrorMessage: 'רשת היישומים חווה שגיאה. רענן את הדף ונסה שוב מאוחר יותר. פנה לתמיכה הטכנית (Help Desk) אם השגיאה נמשכת.',
	genericErrorMessage: 'לא ניתן היה להשלים את הפעולה שנבחרה בשלב זה. רענן את הדף ונסה שנית. פנה לתמיכה הטכנית אם השגיאה נמשכת.',
	otherProjectPlaceholder: 'ההתקשרויות שלך ב- EY Canvas מחוברות לפרויקטים של EY Canvas Oversight המפורטים כאן. אין לך גישה לפרויקטים אלה. שוחח עם אחראי הפרויקט או עם מנהל הקבוצה כדי לקבל גישה.',
	noProjectsAvailable: 'אין פרויקטים זמינים.',
	completedProjectPlaceholder: 'הפרויקטים שהושלמו על ידי EY Canvas Overview מופיעים כאן. בחר באפשרות <b> גלגל קדימה </b> כדי להשתמש בפרויקט שהושלם כתבנית בעת יצירת פרויקט חדש.',
	completedNotProjectPlaceholder: 'אין לך פרויקטים שהושלמו. <br>אם אתה בעל פרויקט, אתה יכול לסמן שהפרויקט הושלם. ניתן לגלגל פרויקטים שהושלמו קדימה ולהשתמש בהם כתבנית בעת יצירת פרויקט חדש.',

	//Log out and time out modal
	logoutModalTitle: 'התנתקות אוטומטית להגנת המידע',
	sessionTimerMsgLine1: 'בגלל חוסר פעילות, משך זמן העבודה הנוכחי שלך עומד להסתיים.',
	sessionTimerMsgLine2: 'למען אבטחתך, הפעלות EY Canvas Oversight מסתיימות אוטומטית לאחר 30 דקות של חוסר פעילות.',
	sessionTimerMsgLine3: 'משך זמן העבודה הנוכחי שלך יפוג בעוד {0} דקות.',
	sessionTimerMsgLine4: 'אם ברצונך להישאר מחובר, אנא לחץ על',
	modalContinueButton: '<b>המשך</b>',
	modalLogoutButton: 'להתנתק',
	modalCloseButton: 'Close',
	countryNotAvailable: 'מדינה לא זמינה',
	regionNotAvailable: 'האזור אינו זמין',
	notAvailable: 'לא זמין',
	signout: 'התנתקות',
	engagementTypeNotAvailable: 'סוג התקשרות אינו זמין',

	// Admin portal
	administration: 'מִנהָל',
	mainPageInstructionalText: 'ברוכים הבאים לפורטל הניהולי של EY Canvas Oversight',
	manageProjectsFormatted: 'ניהול <br />פרויקטים',
	manageUsersFomatted: 'נהל <br />משתמשים',
	manageAdminsFormatted: 'נהל <br />מנהלי פיקוח',
	homeLabel: 'בית',
	userNotFoundError: 'המשתמש לא נמצא.',
	manageUsersInstructionalText: 'חפש משתמש על ידי הזנת ה-GUI שלו',
	selectRole: 'בחר תפקיד',
	role: 'Role',

	//Manage User
	manageUsersTitle: 'ניהול משתמשים',
	otherProjectsTabTitle: 'פרויקטים אחרים',
	validGuiErrorMsg: 'הזן GUI חוקי',
	accessibleProjects: 'פרויקטים נגישים',
	delegates: 'נציגים',
	projectID: 'מזהה פרוייקט',
	projectStatus: 'סטטוס הפרוייקט',
	gui: 'משתמש',
	emailAddress: 'כתובת הדוא"ל',
	userRole: 'תפקיד משתמש',
	userID: 'תעודת זהות של משתמש',
	noResultMessage: 'אין תוצאות שתואמות את קריטריוני החיפוש.',
	noResultFound: 'לא נמצאו שיאים.',
	userDetails: 'פרטי המשתמש',
	active: 'פעיל',
	inActive: 'לא פעיל',
	manageAdmins: 'ניהול מנהלי EY Canvas Oversight',
	manageAdminsInstructionalText: 'כל מנהלי EY Canvas Oversight מפורטים להלן. אתה יכול לערוך את התפקידים של מנהל מערכת, להוסיף ולהסיר מנהלי מערכת.',
	adminReader: 'קורא מנהל אפליקציה',
	adminWriter: 'כותב מנהל אפליקציה',
	superAdmin: 'סופר מנהל אפליקציה',
	revertChanges: 'החזר שינויים',
	unSavedChanges: 'שינויים שלא נשמרו',
	unSavedChangesMessage: 'יש לך שינויים שלא נשמרו שיאבדו אם תמשיך. <br/> בחר <b>אשר</b> כדי להמשיך. בחר <b>ביטול</b> כדי לחזור לדף הבסיסי ולשמור את השינויים שלך.',
	addNewAdmin: 'הוסף מנהל חדש',
	addEYContactInstructions: 'הזן שם או כתובת דואר אלקטרוני והקש Enter כדי לראות תוצאות. בחר תפקיד כדי להוסיף מנהל פיקוח חדש.',

	// ManageProjects
	orgChartEntities: 'ישויות בתרשים ארגוני',
	manageProjectsInstructionalText: 'חפש פרויקט על ידי הזנת מספר מזהה של הפרויקט.',
	projectDetails: 'פרטי הפרוייקט',
	parentEntity: 'ישות אב',
	connectedGroups: 'קבוצות מחוברות',
	validProjectIDError: 'הזן מספר מזהה של פרויקט חוקי',
	addNewMember: 'הוסף חבר',
	adminAddMemberInstructionalText: 'חפש משתמש ובחר את הקבוצות שאליהן יש להוסיף אותו.',
	currentApplication: 'יישום נוכחי',

	//Software Update
	softwareUpdate: 'עדכוני תוכנה',
	updateNow: 'עדכן כעת',
	updateMsg: 'עדכוני תוכנה זמינים עבור EY Canvas Oversight. בחר עדכן כעת כדי להוריד ולהתקין את העדכונים. הדף יעבור רענון.',

	//ContactDB
	placeholderForSearch: 'חפש',
	contactClearAll: 'נקה הכל',
	contactShowMoreFilters: 'עוד',
	contactListFilter: 'גישה לרשימת אנשי הקשר',
	dashboardAccessFilter: 'גישה ללוח המחוונים',
	groupRoleFilter: 'תפקיד בקבוצה',
	tagFilter: 'תגים',
	countryFilter: 'מדינה',
	serviceLineFilter: 'מחלקה',
	typeFilter: 'סוג',
	roleFilter: 'Role',
	dashboardAccess: 'גישה ללוח המחוונים',
	contactList: 'רשימת אנשי קשר',
	noEntitiesMessage1: 'אין נתונים להצגה',
	noEntitiesMessage2: 'בחר ישויות נוספות על מנת להמשיך',
	noContacts: 'אין אנשי קשר עבור ישות זו.',
	engagementsContacts: 'תיקי הביקורת',
	manuallyAdded: 'נוסף ידנית',
	dashboardViews: 'תצוגות דף ראשי (Dashboard)',
	columnName: 'שם',
	columnEmail: 'דואל',
	columnEngagement: 'תיקי הביקורת',
	columnType: 'סוג',
	columnRole: 'Role',
	columnServiceLine: 'מחלקה',
	columnDashboard: 'גישה ללוח המחוונים',
	columnDashboardView: 'תצוגות דף ראשי (Dashboard)',
	columnContactList: 'גישה לרשימת אנשי הקשר',
	columnTags: 'תגים',
	columnEntity: 'ישות',
	noResults: 'לא נמצאו תוצאות',
	noResultsAvailable: 'אין נתונים זמינים.',
	searchContacts: 'חפש אנשי קשר',
	selectedContacts: 'אנשי קשר נבחרים',
	tag: 'תָג',
	manageAccess: 'ניהול גישה',
	formLengthMessage: 'הטקסט אינו יכול לחרוג מ-{number} תווים.',
	viewMoreColumns: 'הצג עמודות נוספות',
	projectOwnerBadge: 'אחראי הפרויקט (Project owner)',
	entityAdminBadge: 'מנהל ישות',
	eyTeam: 'צוות EY',
	clientTeam: 'צוות הלקוח',
	userProfile: 'פרופיל משתמש',
	columnGroupRiskAssessment: 'גישה להערכת סיכונים קבוצתית',
	externalUserDenyMessage: 'External users cannot be granted access to the Group risk assessment module.',
	//ContactDB - Toolbar
	toolbarAddContact: 'הוסף איש קשר',
	toolbarAccessLog: 'יומן הגישה (Access Log)',
	toolbarMessageLog: 'יומן (LOG) הודעות',
	toolbarCustomizeTable: 'התאם אישית את הטבלה',
	toolbarExportData: 'ייצוא נתונים',
	toolbarManageAccess: 'ניהול גישה',
	toolbarDefineAttributes: 'הגדר מאפיינים',
	toolbarGenerateMessage: 'צור הודעה',
	toolbarTags: 'תגים',
	toolbarRemove: 'הסר',

	//ContactDB - Add Contact Modal
	addContactLabel: 'הוסף איש קשר',
	addContactTitle: 'הוסף אנשי קשר',
	addContactInstructional: 'הוסף איש קשר אחד או יותר לפרויקט EY Canvas Oversight שלך. אם אנשי הקשר שאתה מוסיף דורשים גישה ללוח המחוונים או לרשימת אנשי הקשר, תוכל להעניק להם גישה כאן.',
	columnEntities: 'ישויות',
	noEntities: 'אף אחד',
	duplicatedUser: 'כבר נוסף כאיש קשר. אתה יכול לנהל את הגישה שלהם מרשימת אנשי הקשר.',
	accessToDashboard: 'גישה ללוח המחוונים',
	dashBoardsViews: 'גישה ללוח המחוונים ולתצוגה',
	placeholderEntities: 'ישויות',
	placeholderAccess: 'גִישָׁה',
	placeholderAttributes: 'מאפיינים',
	placeholderTags: 'תגים',
	projectOwnerAccessLabel: 'גישה לאחראי על הפרויקט',
	entityAdminAccessLabel: 'גישה לאדמין (Entity Admin)',
	accessToContactListLabel: 'גישה לרשימת אנשי הקשר',
	saveContactLabel: 'שמור',
	cancelContactLabel: 'בטל',
	noContactsAdded: 'עדיין לא נוספו אנשי קשר.',
	noCustomColumns: 'לא נוצרו עמודות מותאמות אישית עבור הפרויקט שלך.',
	toggleContactYes: 'כן',
	toggleContactNo: 'לא',
	mustSelectOneEntity: 'עליך לבחור לפחות ישות אחת כדי להמשיך.',
	mustSelectOneView: 'בחר תצוגה אחת לפחות עבור כל אנשי הקשר שאתה מעניק להם גישה ל- EY Canvas Oversight Dashboard.',
	mustBeOnwerOrAdministrator: 'עליך להיות אחראי הפרויקט (Project owner) או אדמין (entity administrator) בכדי לבצע פעולה זו. בכדי להמשיך, עדכן את הישויות שנבחרו.',
	cannotEditAccessForProjectOwners: 'אינך יכול לערוך גישה לבעלי פרויקטים: {list}',
	attributesLabel: 'מאפיינים',
	externalUserDomainMismatch: 'דומיין אינו מורשה עבור ישות אחת או יותר שנבחרה. הוסף דומיינים נדרשים בתהליך הגדרת הישות ונסה שוב.',
	projectOwnerAccessToogleInfo: 'לבעל פרויקט יש הרשאות מלאות לפרויקט EY Oversight.',
	entityAdminAccessToogleInfo: 'לאדמין (Entity Admin) יש הרשאות ספציפיות לישות לבצע משימות אדמין, לפי הצורך.',

	//ContactDB-CustomizeTable Modal
	customizeTableModal: 'התאם אישית את הטבלה',
	InstructionalTextCustomizeTableModal: 'Select the columns you would like to view.',
	cancelCustomizeTable: 'בטל',
	saveCustomizeTable: 'שמור',
	tooltipCustomizeTable: 'התאם אישית את הטבלה',
	standardColumns: 'עמודות סטנדרטיות',
	customColumns: 'עמודות מותאמות אישית',
	closeTitleModal: 'Close',
	addCustomColumn: 'הוסף עמודה מותאמת אישית',
	editCustomColum: 'ערוך עמודה מותאמת אישית',
	addCustomColumnLegend: 'עמודות מותאמות אישית מאפשרות לך ללכוד ולנהל מאפיינים נוספים לגבי אנשי הקשר שלך. אתה יכול ליצור עד חמש עמודות מותאמות אישית עבור הפרויקט שלך. לאחר יצירת עמודה, תוכל לבחור איש קשר אחד או יותר ולהגדיר מאפיין. אם תסיר עמודה מותאמת אישית, גם מאפיינים של אנשי קשר יוסרו.',
	deleteCustomColumnLegend: 'בחר באפשרות <b>מחק</b> כדי למחוק עמודה מותאמת אישית. אם תמשיך, היא לא תהיה זמינה יותר עבור הפרויקט שלך. כל המאפיינים שהחלת בעבר על אנשי קשר יימחקו גם הם.',
	customColumnName: 'שם עמודה',
	attribute: 'מאפיין',
	attributes1to5: 'מאפיינים (1-5)',
	visibleToExternal: 'גלוי לאנשי קשר חיצוניים',
	noCustomColumnMsg: 'No custom column added',

	//ContactDB - Add Contact Modal
	filterTooltip: 'סנן',
	searchTitletip: 'חפש',
	addExternalContactColumnName: 'שם',
	addExternalContactColumnDomain: 'דומיין (domain)',
	confirmDomain: 'אשר את הדומיין',

	//ContactDB - Profile Modal
	profileModalTitle: 'פרופיל',
	profileModalAccessSection: 'גִישָׁה',
	profileModalCustomAttributesSection: 'מאפיינים מותאמים אישית',
	profileModalDashboardSection: 'תצוגות דף ראשי (Dashboard)',

	//ContactDB - Generate Message
	selectMessageRecipients: 'בחר נמענים להודעה',
	notification: 'הודעה',
	generateMessage: 'צור הודעה',
	gmInstructionalText: "שלח אימייל או התראה לאנשי הקשר שבחרת. ניתן לשלוח התראות רק לאנשי קשר פנימיים. ניתן לשלוח מיילים לאנשי קשר פנימיים וחיצוניים.",
	messageType: 'סוג הודעה',
	messageRecipient: 'נמעני הודעה',
	selectContactsNow: 'בחר אנשי קשר כעת',
	useSelectedContacts: 'השתמש באנשי הקשר שנבחרו',
	moreFilters: '+ מסננים נוספים',
	countries: 'מדינות',
	groupRoles: 'תפקידים בביקורת הקבוצה',
	groupRole: 'תפקיד בקבוצה',
	roles: 'תפקידים',
	role: 'Role',
	serviceLines: 'קווי שירות SLs',
	serviceLine: 'מחלקה',
	contatcs: 'אנשי קשר',
	singularContact: 'איש קשר',
	singularEngagement: 'תיק ביקורת',
	allContact: 'כל אנשי הקשר',
	allEntitles: 'כל הישויות',
	allCountries: 'כל המדינות',
	allGroupRoles: 'כל התפקידים בביקורת הקבוצה',
	allEngagements: 'כל ההתקשרויות',
	allServicesLines: 'כל קווי השירות SL',
	allRoles: 'כל התפקידים',
	subject: 'נושא',
	removeTooltip: 'הסר',
	fromEntity: 'מישות',
	fromEngagement: 'מתוך תיק הביקורת',
	notificationMessage: 'הודעת התראה',
	linkLabel: 'תווית קישור (אופציונלי)',
	link: 'קישור (אופציונלי)',
	fromEntityNotification: 'מישות',
	mustSelectOne: 'עליך לבחור לפחות איש קשר אחד כדי להמשיך.',
	emailSentMsg: 'הודעת דואר אלקטרוני נוצרה לאנשי הקשר שנבחרו.',
	notificationSentMsg: 'התראה נשלחה לאנשי הקשר שנבחרו.',
	messageFrom: 'הודעה מאת',
	duplicateMessage: 'הודעה כפולה',
	someEntities: '{0} entities selected',

	//ContactDB - Message Log
	messageLogInstruction: 'סקור את רשימת ההודעות שנשלחו על ידי הישות שלך. אם אתה צריך לשלוח הודעת המשך, יש לך אפשרות לשכפל הודעות קודמות.',
	messageLogTitle: 'יומן (LOG) הודעות',
	today: 'היום',
	yesterday: 'אתמול',
	thisWeek: 'השבוע',
	lastWeek: 'בשבוע שעבר',
	twoWeeksAgo: 'לפני שבועיים',
	older: 'ישן יותר',
	notificationTo: 'התראה ל',
	emailTo: 'שלח דואר אלקטרוני אל',
	sentBy: 'נשלח על-ידי',
	from: 'מ',
	date: 'תאריך',
	time: 'זְמַן',
	subject: 'נושא',
	multiContatcsLowerCase: 'אנשי קשר',
	singleContactLowerCase: 'איש קשר',
	seeMore: 'הצג יותר',
	seeLess: 'הצג פחות',
	messageLogEmptyMessage: 'עדיין לא נשלחו הודעות.',
	messageLogFileExported: 'יומן (LOG) הודעות',
	typeColumnToExportToExcel: 'סוג',
	sentByColumnToExportToExcel: 'נשלח על-ידי',
	fromColumnToExportToExcel: 'מ',
	dateColumnToExportToExcel: 'תאריך',
	timeColumnToExportToExcel: 'זְמַן',
	subjectColumnToExportToExcel: 'נושא',
	contactsColumnToExportToExcel: 'אנשי קשר',
	emailExportToExcel: 'דואל',
	notificationExportToExcel: 'הודעה',

	//ContactDB - Access Log
	accessLog: 'יומן הגישה (Access Log)',
	accessLogInstructional: 'סקור את חברי הצוות המוצגים להלן, והחלט האם להוסיף או להסיר אותם כאנשי קשר.',
	addAll: 'הוסף הכל',
	removeAll: 'להסיר את כל',
	ignoreAll: 'התעלם מהכל',
	contactsToAddEmpty: 'אין אנשי קשר פוטנציאליים להוספה בשלב זה.',
	contactsToRemoveEmpty: 'אין אנשי קשר פוטנציאליים להסרה בשלב זה.',
	ignore: 'התעלם',
	addAllConfirmationModal: 'למשתמש אחד או יותר יש דומיין שאינו מורשה על ידי ישות. לחץ על המשך כדי להוסיף את המשתמשים לרשימת אנשי הקשר. הדומיינים ייובאו ויתווספו לרשימת הדומיינים המותרים עבור הישות.',
	addConfirmationModal: 'למשתמש יש דומיין שאינו מורשה על ידי ישות זו. לחץ על המשך כדי להוסיף את המשתמש לרשימת אנשי הקשר. הדומיין יובא ויתווסף לרשימת הדומיינים המותרים עבור הישות.',

	// ContactDB - Message Log - Filter
	messageTypeFilter: 'סוג הודעה',
	sentByFilter: 'נשלח על-ידי',
	fromEntityFilter: 'מישות',
	toEntityFilter: 'לישות',
	toCountryFilter: 'למדינה',
	toGroupRoleFilter: 'לתפקיד בקבוצה',
	toEngagementFilter: 'לתיק הביקורת',
	toServiceLineFilter: 'לקו השירות (SL)',
	toRoleFilter: 'לתפקיד',

	//ContactDB - Define Attributes
	defineAttributes: 'הגדר מאפיינים',

	// ContactDB Edit Entity Modal
	// Step 2 - Edit Entity Modal
	addAnotherEntityAdministrator: 'הוסף עוד מנהל ישות',
	editEntity: 'ערוך ישות',
	entityAdministrators: 'מנהלי ישויות (אופציונלי)',
	editEntityAdministratorsInstruction: 'יש לך אפשרות להוסיף מנהל ישות אחד או יותר. הם יכולים להוסיף אנשי קשר לישות זו ולהעניק גישה למודולי EY Canvas Oversight.',
	editEntityDomainInstruction: 'חברי צוות חיצוניים חייבים להיות בעלי דומיין חוקי כדי שהישות הזו תוכל לגשת ל-EY Canvas Oversight. המערכת תייבא דומיינים מאושרים מהתקשרויות מחוברות ל- EY Canvas בשלב 4 של אשף ההגדרה. אם אתה מתכנן להזמין חברי צוות חיצוניים אחרים לישות זו, הוסף דומיין אחד או יותר. דומיין הוא התווים שאחרי הסימן @ בכתובת דוא"ל.',
	level: 'רמה {0}',

	// ContactDB Remove Contacts
	removeIcon: 'הסר',
	removeContactTitle: 'Remove contacts',
	removeInstructionalText: 'האם אתה בטוח שברצונך להסיר אנשי קשר אלה מהפרויקט שלך? אם אנשי הקשר הללו שייכים למספר ישויות, אז הם יוסרו מכל הישויות. אם עליך להסיר איש קשר מיישות בודדת, בחר באפשרות עריכת  הגישה שלו במקום זאת.',
	removeSelectedContacts: 'אנשי קשר נבחרים',

	domainNotPermitted: 'הדומיין (domain) של אדמין (entity administrator) אחד או יותר אינו מורשה עבור ישות זו.',
	listView: 'תצוגת רשימה',
	cardView: 'תצוגת כרטיס',

	recordsNotAvailable: 'רשומות לא זמינות',

	// Project Layout Update
	welcomeLabel: 'Welcome',
	activeProjectsInstructionalText: 'יש לך גישה לפרויקטים של EY Canvas Oversight המפורטים כאן. בחר מודול כדי לנווט אליו או לחץ על מספר כדי לראות פרטים עבור כל אחד מהפרויקטים שלך.',
	otherProjectsInstructionalText: 'ההתקשרויות שלך ב-EY Canvas קשורות לפרויקטים של EY Canvas Oversight המפורטים כאן. אין לך גישה לפרויקטים האלה. דבר עם האחראי על הפרויקט או עם מנהל הישות בכדי לקבל גישה.',
	completedProjectsInstructionalText: 'הפרויקטים שהושלמו של EY Canvas Oversight מפורטים כאן. בחר באפשרות <b>גלגל קדימה</b> בכדי להשתמש בפרויקט שהושלם כתבנית בעת יצירת פרויקט חדש.',
	goToLabel: 'לך ל',
	entityAdmins: 'מנהלי ישות',
	entityAdmin: 'מנהל ישות',
	keyContacts: 'אנשי קשר עיקריים',
	keyContact: 'איש קשר מרכזי',
	contactListLabel: 'רשימת אנשי קשר',
	draftlabel: 'טיוטה',
	projectWizard: 'אשף הפרויקט',
	noEntityAdminsAdded: 'לא משויכים מנהלי ישות',
	addProjectOwner: 'הוסף אחראי על הפרויקט',
	addProjectOwnerInstrText: 'חפש משתמש לפי שמו או כתובת הדוא"ל שלו בכדי להוסיף אותו כאחראי על הפרויקט בפרויקט הנבחר.',
	projectSummary: 'סיכום הפרויקט',
	privacyNotice: 'הודעת פרטיות',
	groupOversightProject: 'פרויקט Oversight קבוצתי (חדש!)',
	groupOversightProjectTooltip: 'ב<b>פרויקטים של Oversight קבוצתי</b>, אתה יכול לזהות את ההתקשרות הראשית ו/או האזורית של ה- EY Canvas שעבורם אתה יוצר פרויקט EY Oversight. ההתקשרות האזורית ו/או הישויות המוחזקות של ה- EY Canvas שזוהו במבנה קבוצת EY Canvas שלך ימולאו <b>אוטומטית</b> כחלק מהגדרת הפרויקט של EY Oversight. <br><br> בנוסף, לסוגים אלה של פרויקטים תהיה גישה למודול הערכת סיכונים קבוצתי שבו ניתן לצפות בפעילויות הערכת סיכונים עבור ההתקשרות הראשית, האזורית ו/או הרכיבים.',
	oversightProject: 'פרויקט Oversight (ביקורות סטטוטורית)',
	oversightProjectTooltip: 'בפרויקטים של Oversight (ביקורת סטטוטורית), אתה יכול לבחור ידנית את הלקוחות שלך, ולאחר מכן את ההתקשרויות הקשורות ל-EY Canvas, עבורם אתה יוצר פרויקט EY Oversight.',

	// Group Risk Assessment
	noGroupRiskAssessmentForSelection: 'אין פעילות הערכת סיכונים קבוצתית עבור פרויקט EY Oversight זה',
	engagementData: 'נתוני ההתקשרות',
	engagementDetails: 'פרטי התקשרות',
	reconciliations: 'התאמות',
	nextComponent: 'הישות המוחזקת הבאה',
	prevComponent: 'ישות מוחזקת (CT) קודמת',
	allAccounts: 'כל הסעיפים',
	generateEmail: 'צור אימייל',
	reconciliationDetailInstructional: 'The information below summarizes the total number of Primary Team accounts, and risks of material misstatement, which were related to the component in the Primary Team\'s EY Canvas engagement and included in the group risk assessment communications. Select a Primary Team account/risk to relate it to the equivalent account/risk in the component team\'s EY Canvas engagement.',
	primaryTeamAccountName: 'Primary Team account name',
	componentTeamAccountName: 'שם חשבון צוות הביקורת של ישות מוחזקת',
	designation: 'ייעוד',
	openAccounts: 'פתח חשבונות',
	componentTeamAccounts: 'חשבונות צוות ביקורת ישות מוחזקת (CT)',
	componentTeamAccountsAndPsp: 'Component team accounts and related PSP Index(es)',
	mapAccountsMessage: 'Each Primary Team account should have at least one related component team account. {button} to get started.',
	primaryTeamAccountStatus: 'Primary Team account status',
	totalAccounts: 'סה"כ חשבונות',
	assessedAccounts: 'סעיפים שנעשתה להם הערכה',
	primaryTeamRiskStatus: 'Primary Team risk status',
	openRisks: 'סיכונים פתוחים',
	assessedRisks: 'הערכת סיכונים',
	totalRisks: 'סך סיכונים',
	primaryTeamRiskDesignationAndName: 'Primary Team risk designation and name',
	primaryTeamAccountsRelatedToRisk: 'חשבונות צוות ראשיים הקשורים לסיכון',
	componentTeamRisksAndRelatedAccounts: 'סיכונים של צוות הביקורת של ישות מוחזקת (CT) וחשבונות קשורים',
	relateRisks: 'קשר סיכונים',
	relateRisksMessage: 'Each Primary Team risk should have at least one related component team risk. {button} to get started.',
	pspIndexesHeader: 'PSP',
	pspIndexes: 'אינדקס(ים) PSP',
	markAssessed: 'מארק הוערך',
	markReOpen: 'פתח מחדש',
	riskMarkAssessedMessage: 'View related component team risks to assess whether risk designations, accounts and relevant assertions match the Primary Team risks and accounts included in the Primary Team group risk assessment communication. When complete, {button}.',
	riskWasPreviousAssessedMessage: "Status changed from Assessed to Open due to changes in the related risk, risk designation, account or assertions. Re-assess the risk grouping. When complete, {button}.",
	riskMarkOpenMessage: 'If changes need to be made to a risk grouping that has already been marked assessed, {button} the risk grouping. This risk grouping will appear in the Open risks view.',
	markAssessedSuccessMessage: 'The account grouping has successfully been marked assessed. To review, click \'Assessed accounts\' in the account status tile.',
	reopenAssessedAccount: 'פתח מחדש',
	reopenAssessedAccountMessage: 'If changes need to be made to an account grouping that has already been marked assessed, {button} the account grouping. This account grouping will appear in the Open accounts view.',
	reopenSuccessMessage: 'The account grouping has successfully been re-opened. To view, click \'Open accounts\' in the account status tile.',
	teamAccountMappedMessage: 'View related component team accounts to assess whether account designations, relevant assertions and inherent risk assessments match the Primary Team accounts included in the Primary Team group risk assessment communication. When complete, {button}.',
	teamAccountWasPreviousAssessedMessage: 'Status changed from Assessed to Open due to changes in the related account, account designation or inherent risk assessment. Re-assess the account grouping. When complete, {button}.',
	createComment: 'צור תגובה',
	editComment: 'ערוך תגובה',
	commentTitle: 'הערה',
	createCommentInstructionalText: "הזן פרטי הערה עבור הסעיף או הסיכון שנבחרו ובחר 'שמור' כדי לסיים.",
	editCommentInstructionalText: "ערוך את פרטי ההערה עבור הסעיף או הסיכון שנבחרו ובחר 'שמור' כדי לסיים.",
	lastModified: 'שונה לאחרונה',
	addComment: 'הוסף תגובה',
	accountDescription: "בחר 'פתח חשבונות' בכדי להציג חשבונות ברמת צוות הביקורת של חברת האם (PT) שלא היו מקושרים לחשבונות ברמת צוות הביקורת של הישות המוחזקת (CT) וסומנו ככאלו בהערכת הסעיפים. בחר בהערכת הסעיפים בכדי להציג חשבונות ברמת צוות הביקורת של חברת האם (PT) שהוערכו.",
	riskDescription: "בחר 'פתח סיכונים' בכדי להציג סיכונים ברמת צוות הביקורת של חברת האם (PT) שלא היו מקושרים לסיכונים ברמת צוות הביקורת של הישות המוחזקת (CT) וסומנו ככאלו בהערכת סיכונים. בחר בהערכת סיכונים כדי להציג סיכונים ברמת צוות הביקורת של חברת האם (PT) שהוערכו.",
	successAssessedMessage: 'The risk grouping has successfully been marked assessed. To review, click \'Assessed risks\' in the risk status tile.',
	successReOpenMessage: 'The risk grouping has successfully been re-opened. To view, click \'Open risks\' in the risk status tile.',

	// Relate risks modal
	relateRisksModalTitle: 'Relate component team risks',
	relateRisksModalInstructionalText: 'Select risk(s) from the component team\'s EY Canvas engagement listed below to relate to the selected Primary Team risk.',
	primaryRegionTeamRisk: 'Primary Team risk:',
	primaryTeamRiskLabel: 'סיכון צוות הביקורת של חברת האם (PT)',
	thereIsNoDataToDisplayForThisSelection: 'אין נתונים להצגה עבור בחירה זו.',
	accountAndAsssociated: 'Account(s) and associated PSP index(es)',
	noAccountOrPspAssociated: 'There is not account or associated PSP index.',
	disabledRegionComponentTeamRiskLabel: "סיכון זה ברמת צוות הביקורת של ישות מוחזקת (CT) כבר ממופה לסיכון צוות הביקורת של חברת האם (PT) אחר. ניתן למפות סיכון צוות הביקורת של ישות מוחזקת (CT) רק לסיכון צוות הביקורת של חברת האם (PT) אחד. בחר 'קשר סיכונים' עבור הסיכון של חברת האם הרלוונטי כדי לבטל את הקשר לסיכון זה, לפי העניין.",
	selectOneOrMore: 'בחר אחד או יותר',

	relateAccountsModalTitle: 'Relate component team accounts',
	relateAccountName: 'Primary Team account:',
	relateAccountpspIndexes: 'PSP index(es):',
	relateAccountInstructionalText: 'Select account(s) from the component team\'s EY Canvas engagement listed below to relate to the selected Primary Team account.',
	pspIndexcountLabel: 'אינדקסים של PSP הקשורים לסעיף ברמת צוות הביקורת של חברת האם (PT) / צוות ביקורת אזורי (RT)',
	relateAccounts: 'חשבונות קשורים',

	viewComponentTeamAccountsText: 'View component team accounts not related and/or not applicable',
	componentTeamAccountsModalTitle: 'סעיפים ברמת צוות הביקורת של ישות מוחזקת (CT)  אינם קשורים ו/או אינם רלוונטיים',
	componentTeamAccountsModalInstructionalText: "The list below displays the account(s) in the component team's EY Canvas engagement that are not related to a Primary Team account. Return to the component team reconciliation details screen to relate an account to a Primary Team account. Alternatively, if a component team account is not applicable to the group audit, mark as 'Not applicable'. <br/><br/> Marking an account 'Not applicable' will move the account to the 'Not applicable' tab. Accounts should be marked 'Not applicable' if they are not applicable to the group audit.",
	componentTeamAccountsModalNotApplicableInstructionalText: '\'Not applicable\' component team account(s) are marked this way because they are not applicable to the group audit. <br/><br/> If an account is listed below in error, select \'Undo not applicable\' to move the account to the \'Not related\' tab. Account(s) that are \'Not related\' should either be related to a Primary Team account in the Relate component team accounts modal or marked \'Not applicable\' if not applicable to the group audit.',
	notRelatedTab: 'לא קשור',
	notApplicableTab: 'לא ישים',
	unmapped: 'לא מופה',
	unrelate: 'לא קשור',
	undoNotApplicable: 'Undo not applicable',
	action: 'פעולה',
	notApplicableActionTitletip: "בחירה ב'לא קשור' תעביר את הסיכון ללשונית 'לא קשור'. סיכונים שהם 'לא קשורים' צריכים להיות קשורים לסיכון צוות הביקורת של חברת האם (PT) או להיות מסומנים 'לא רלוונטי' אם הם אינם רלוונטיים לביקורת הקבוצתית.",
	notRelatedActionTitletip: "בחירה ב'לא רלוונטי' תעביר את הסיכון לכרטיסייה 'לא רלוונטי'. סיכונים של צוות הביקורת של ישות מוחזקת (CT) שהם 'לא רלוונטיים' אינם חלים על הביקורת הקבוצתית.",

	higherInheritRisk: 'סיכון מובנה גבוה יותר',
	lowerInheritRisk: 'סיכון מובנה נמוך יותר',
	incompleteInheritRisk: 'Incomplete inherent risk',
	riskAssociated: 'סיכון קשור',
	riskAssociatedHigher: 'סיכון מקושר הגורם לסיכון שבמהות  להיות גבוה יותר',
	
	viewComponentTeamRisks: 'View component team risks not related and/or not applicable',
	unmappedRisksModalTitle: 'סיכונים של צוות הביקורת של ישות מוחזקת (CT)  אינם קשורים ו/או אינם רלוונטיים',
	unmappedRisksModalInstructional: 'The list below displays the risk(s) in the component team\'s EY Canvas engagement that are not related to a Primary Team risk. Return to the component team reconciliation details screen to relate a risk to a Primary Team risk. Alternatively, if a component team risk is not applicable to the group audit, mark as \'Not applicable\'. <br/><br/> Marking a risk \'Not applicable\' will move the risk to the \'Not applicable\' tab. Risks should be marked \'Not applicable\' if they are not applicable to the group audit.',
	notApplicableRisksModalInstructional: "'Not applicable' component team risk(s) are marked this way because they are not applicable to the group audit. <br/><br/> If a risk is listed below in error, select 'Undo not applicable' to move the risk to the 'Not related' tab. Risk(s) that are 'Not related' should either be related to a Primary Team risk in the Relate component team risks modal or marked 'Not applicable' if not applicable to the group audit.",
	added: 'נוסף',

	groupRiskAssessmentInstructional: "The Group risk assessment Reconciliation allows the Primary Team to view the accounts and risks of material misstatement created in the component team's EY Canvas engagement.<br><br>Click on a component name below to open the component reconciliation screen where the Primary Team can relate the accounts and risks of material misstatement that were related to the component in the Primary Team's EY Canvas engagement to the accounts and risks of material misstatement that exist in the component team's EY Canvas engagement.<br><br>The Reconciliation can assist the Primary Team to identify any deviations from the group risk assessment information communicated in the group instructions, such as differences in accounts, account designations, relevant assertions, inherent risk assessments, and identified risks of material misstatement and help facilitate group involvement discussions with component teams.",
	groupRiskAssessmentActivityFeedInstructional: "The Activity feed allows the Primary Team to view any changes to the risk assessment made by the component teams in their local EY Canvas engagement. Activities highlighted include changes made in the underlying component EY Canvas engagement to accounts, account designations, assertions and identified risks of material misstatements since the creation of the EY Canvas Oversight project. This is not reflecting activity in the Reconciliation.",
	disclaimerInstructional: 'The EY Canvas Oversight Group risk assessment functionality can support effective project management by a Primary Team in a group audit. However, this functionality is not intended to provide, document or generate audit evidence. Further, it is not intended to replace the Primary Team\'s involvement in the component team\'s work, including review of component teams reporting deliverables. We do not include screenshots or data exported from EY Canvas Oversight in the Primary Team\'s EY Canvas as evidence of the Primary Team\'s involvement in, or supervision of, the work of component teams.'
};

export const temporaryLabels = {
	dryDock: 'Drydock',
	darkMode: 'מצב כהה',
	dashboard: 'Dashboard',
	projects: 'פרויקטים',
	scopeStrategy: 'היקף ואסטרטגיה',
	accountSummary: 'סיכום הסעיפים',
	scotSummary: 'סיכום תתי התהליכים המהותיים (SCOTs)',
	craSummary: 'סיכום הערכת הסיכון המשולב (CRA)',
	itSummary: 'סיכום IT',
	SPSummary: 'Substantive Evaluation Summary (SEM)',
	auditPlan: 'תוכנית ביקורת',
	conclusion: 'מסקנה',
	findings: 'ממצאים',
	changesReport: 'שינויים לאחר תאריך הדיווח',
	teamMember: 'אי תלות חבר צוות',
	archiveChecklist: 'שאלון לביצוע ארכיב',
	enagagementmanagement: 'ניהול תיק הביקורת',
	integration: 'אינטגרציה',
	guidedWorkflow: 'מדריך לתהליך',
	copyrightMessage: 'זכויות יוצרים © <שנה>. כל הזכויות שמורות'
};

export const createGRAProjectLabels = {
	creationInstructional: "הזן שם פרויקט ובחר התקשרות EY Canvas של צוות ביקורת ראשי (PT) או אזורי (RT) אחד מהרשימה שלהלן כדי ליצור פרויקט EY Oversight. <br> בהתבסס על ההתקשרות שנבחרה, ההתקשרויות של EY Canvas המזוהות במבנה EY Canvas Group ימולאו באופן אוטומטי כחלק מהגדרת פרויקט זה. לחץ על {link} לקבלת מידע נוסף אודות EY Canvas Oversight.",
	projectName: labels.projectName,
	engagements: labels.engagementsLabel,
	searchPlaceholder: 'חפש שם, מזהה או שם לקוח של ההתקשרות ב- EY Canvas',
	noAccessToEng: 'אין לך גישה לכל ההתקשרויות של ה-EY Canvas.',
	noDataToDisplay: labels.noDataFound,
	save: labels.save,
	cancel: labels.cancelLabel,
	engagementsRequiredMessage: 'בחר התקשרות אחת לפחות לשמירה.',
	userGuideLinkText: 'מדריך למשתמש'
};

export const deleteCommentModalLabels ={
	titleText: 'מחק הערה',
	instructionalText: 'האם אתה בטוח שברצונך למחוק את התגובה?',
	triggerText: 'מחק',
	confirmLabel: 'אשר',
	cancelLabel: 'בטל',
	closeLabel: 'Close',
}

export const gaRoleType = [{
		id: GARoleTypeId.Primary,
		label: 'צוות ראשי'
	},
	{
		id: GARoleTypeId.Region,
		label: 'אזור (region)'
	},
	{
		id: GARoleTypeId.Component,
		label: 'ישות מוחזקת (component)'
	}
];

export const engagementTableLabels = {
	engagementName: 'שם ההתקשרות',
	clientName: labels.clientName,
	type: labels.typeLabel,
	gaRoleType
};

export const formLabels = {
	required: labels.required,
	maxLength: labels.formLengthMessage
};

export const activityLogTypes = {
	ProjectCreated: 'תאריך יצירת הפרויקט',
	GAComponentCreated: 'הישות המוחזקת נוספה',
	GAComponentRemoved: 'הישות המוחזקת הוסרה',
	GAComponentUnlinked: 'הישות המוחזקת לא קושרה',
	AccountAdded: 'החשבון נוסף',
	AccountRemoved: 'החשבון הוסר',
	AccountDesignationChanged: 'ייעוד החשבון השתנה',
	AccountEstimateChanged: 'סעיף הכולל אומדן השתנה',
	AccountExecutionTypeChanged: 'סוג ביצוע חשבון השתנה',
	AssertionAssociated: 'מצג הנהלה קשור',
	AssertionUnassociated: 'מצג הנהלה לא קשור',
	AssertionInherentRiskChanged: 'שינוי בסיכון המובנה',
	AssertionControlRiskDesignationChanged: 'שינוי ייעוד סיכון בקרה',
	RiskCreated: 'נוצר סיכון',
	RiskRemoved: 'הסיכון הוסר',
	RiskAssociated: 'סיכון קשור',
	RiskUnassociated: 'סיכון לא קשור'
};

export const activityTableLabels = {
	sourceEngagement: 'מקור תיק הביקורת',
	activityType: 'סוג הפעילות',
	objectImpacted: 'האובייקט מושפע',
	relatedObjectImpacted: 'אובייקט קשור מושפע',
	relatedSecondaryObjectImpacted: 'אובייקט משני קשור מושפע',
	activityDate: 'תאריך פעילות'
};

export const regionComponentRiskTableLabels = {
	regionComponentTeamRiskName: 'Component team risk name and risk designation',
	details: 'פרטים'
};

export const riskTypes = [{
		id: '1',
		label: 'סיכון משמעותי (Significant Risk)'
	},
	{
		id: '2',
		label: 'סיכון תרמית'
	},
	{
		id: '3',
		label: 'סיכון שבמהות (Inherent Risk)'
	}
];

export const engagementLabels = {
	accountName: 'שם סעיף / גילוי',
	accountTypeName: 'ייעוד',
	canvasEngagementId: 'מזהה תיק הביקורת',
	controlRiskTypeName: 'בקרת סיכון',
	engagementDescription: 'שם ההתקשרות',
	inherentRiskTypeName: 'סיכון שבמהות (Inherent Risk)',
	assertionName: 'יעד הנהלה',
	pspIndexTitle: 'אינדקס PSP',
	riskName: 'שם הסיכון',
	riskTypeName: 'סוג הסיכון',
	relatedTasks: 'משימות קשורות',
	taskStatus: 'סטטוס המשימה',
	controlRiskAssessment: 'הערכת הסיכון המשולב (CRA)'
};

export const groupRiskAssessmentLabels = {
	activityFeed: labels.activityFeed,
	reconciliations: labels.reconciliations,
	lastRefreshed: labels.lastRefreshed,
	groupRiskAssessment: labels.groupRiskAssessment,
	lastRefreshedReconciliation: labels.lastRefreshedReconciliation,
	lastRefreshedActivityFeed: labels.lastRefreshedActivityFeed,
	groupRiskAssessmentInstructional: labels.groupRiskAssessmentInstructional,
	groupRiskAssessmentActivityFeedInstructional: labels.groupRiskAssessmentActivityFeedInstructional,
	disclaimerInstructional: labels.disclaimerInstructional
};

export const reconciliationsTableLabels = {
	show: labels.show,
	noDataToDisplay: 'אין נתונים להצגה עבור טבלה זו.',
	unselectedEntities: 'אין נתוני התאמה עבור פרויקט EY Oversight זה. קשר ישויות מוחזקות לסעיפים בתהליך הנחיות הקבוצה בהתקשרות של צוות הביקורת של חברת האם (PT) שלך ב-EY Canvas כדי שנתוני התאמה יוצגו כאן.',
	columns: {
		components: 'ישויות מוחזקות',
		open: 'פתח',
		assessed: 'מוערך',
		total: 'סך הכול'
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent
};

export const relateAccountsTableLabels = {
	show: labels.show,
	noDataFound: labels.noDataFound,
	columns: {
		accountName: 'סעיף ברמת צוות הביקורת של ישות מוחזקת (CT)',
		pspIndexes: 'אינדקס(ים) PSP'
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent,
	relateAccountTableDisabledRowToolTip: "סעיף צוות הביקורת של ישות מוחזקת (CT) זה כבר ממופה לסעיף ברמת צוות הביקורת של חברת האם (PT) אחר. ניתן למפות סעיף ברמת צוות הביקורת של ישות מוחזקת (CT) לסעיף ברמת צוות הביקורת של חברת האם (PT) אחד בלבד. בחר 'קשר סעיפים' עבור הסעיף של חברת האם הרלוונטית בכדי לבטל את הקשר לסעיף זה, לפי העניין."
};

export const notRelatedAccountsTableLabels = {
	show: labels.show,
	noDataFound: labels.noDataFound,
	columns: {
		accountName: relateAccountsTableLabels.columns.accountName,
		pspIndexes: 'אינדקס(ים) PSP',
		notRelated: {
			actionColumnName: labels.action,
			titleTip: 'סימון סעיף \'לא רלוונטי\' יעביר את הסעיף ללשונית \'לא רלוונטי\'. יש לסמן סעיפים \'לא רלוונטי\' אם הם אינם רלוונטיים לביקורת הקבוצה.',
			actionLabel: labels.notApplicableTab
		},
		notApplicable: {
			actionColumnName: labels.action,
			titleTip: "בחירה ב\'לא קשור\' תעביר את הסעיף ללשונית \'לא קשור\'. סעיפים שהם \'לא קשורים\' צריכים להיות קשורים לסעיף ברמת צוות הביקורת של חברת האם (PT) או להיות מסומנים כ'לא רלוונטי\' אם הם לא רלוונטיים לביקורת הקבוצה.",
			actionLabel: labels.undoNotApplicable
		}
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent
};

export const unmappedRisksTableColumnLabels = {
	riskName: "סיכון ברמת צוות הביקורת של ישות מוחזקת (CT)",
	actions: "פעולה"
};

export const AdminUserErrors = {
	userError: 'המשתמש לא נמצא.'
};

/*RBAC Errors*/
export const RbacErrors = {
	106: "אין לך את ההרשאות הנדרשות לביצוע פעולה זו."
};

export const Errors = {
	106: "אין לך את ההרשאות הנדרשות לביצוע פעולה זו.",
	107: "אין לך את ההרשאות הנדרשות לביצוע פעולה זו.",
	111: 'אינך יכול להאציל את הגישה לעצמך.',
	112: 'המשתמש לא נמצא.',
	117: 'You cannot delegate access to an external user.',
	310: 'הפרוייקט לא נמצא',
	314: 'הדומיין (domain) עבור מנהל קבוצה אחד או יותר אינה מותרת עבור קבוצה זו.',
	316: 'עליך להיות האחראי על הפרוייקט או מנהל קבוצה כדי להוסיף חברי צוות. דבר עם אחראי הפרוייקט בכדי לקבל גישה.',
	317: 'ניתן להוסיף רק חברי צוות פנימיים כאחראיים על פרויקטים. להלן המשתמשים החיצוניים: {0}. רענן את הדף ונסה שוב. צור קשר עם התמיכה הטכנית במידה והשגיאה נמשכת.',
	318: 'הדומיין עבור {0} אינו מורשה עבור הקבוצה הבאה: {1}',
	319: 'פרוייקט זה הושלם על-ידי אחראי פרוייקט אחר. רענן את הדף ונסה שוב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית.',
	321: 'בכדי להשלים פעולה זו, עליך להיות האחראי על הפרוייקט . אנא פנה אל אחראי הפרוייקט בכדי לקבל גישה.',
	323: 'קבוצה זו נמחקה על-ידי חבר צוות אחר. רענן את הדף ונסה שוב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית.',
	324: 'עליך להיות אחראי הפרוייקט בכדי להשלים פרויקט זה. רענן את הדף ונסה שוב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית.',
	325: 'עליך להיות אחראי פרוייקט או מנהל קבוצה בכדי לבצע שינויים אלה. דבר עם אחראי הפרוייקט בכדי לקבל גישה.',
	326: 'השלם את כל השדות הנדרשים לשמירת פרוייקט זה. רענן את הדף ונסה שוב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית.',
	327: 'הפרוייקט כבר נשמר.',
	328: 'חבר הצוות שאתה מנסה להוסיף כבר חבר בקבוצה זו. רענן את הדף ונסה שנית.',
	330: 'לא ניתן למחוק את אחראי הפרויקט האחרון',
	331: 'קבוצה אחת או יותר נמחקו על ידי חבר צוות אחר. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.',
	332: 'נדרש שיהיה לפחות בעל פרויקט אחד. אינך יכול להסיר את עצמך מפרויקט זה.',
	341: 'אין לך גישה ללקוחות או התקשרויות נבחרות.',
	343: 'אתה יכול למחוק רק פרויקטים פעילים וטיוטות. רענן את הדף ונסה שוב. פנה לדלפק העזרה אם השגיאה נמשכת.',
	344: 'עליך להיות בעל פרויקט כדי למחוק את הפרויקט הזה. רענן את הדף ונסה שוב. פנה לדלפק העזרה אם השגיאה נמשכת.',
	345: 'פרויקט זה נמחק על ידי חבר צוות אחר. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.',
	346: 'אחראי הפרויקט (Project owner) או אדמין (entity administrator) אחר כבר בדק את הגישה של {0}. רענן את יומן הגישה (Access Log) ונסה שנית.',
	347: 'עליך להיות אחראי הפרויקט (Project owner) או אדמין (entity administrator) בכדי להוסיף או להסיר אנשי קשר מהפרויקט הזה. שוחח עם  אחראי הפרויקט (Project owner) בכדי לבקש גישה.',
	348: 'אתה יכול להסיר אנשי קשר רק מהישויות שאתה מנהל. אנשי הקשר הבאים שייכים לישויות שאינך  אדמין (administrator) ולא ניתן להסירן: {0}.',
	360: 'עליך להיות בעלים של הפרויקט עבור פרויקט זה כדי להשלים פעולה זו.',
	361: 'עליך להיות אחראי פרויקט או מנהל ישות בכדי לבצע פעולה זו. שוחח עם אחראי הפרויקט בכדי לבקש גישה.',
	362: 'אתה יכול לנהל גישה רק עבור אנשי קשר המשויכים לישויות שאתה מנהל. אנשי הקשר הבאים שייכים לישויות שאינך מנהל מערכת עבורן, ולא ניתן לערוך את הגישה שלהם: {0}.',
	364: 'אתה מנסה לערוך גישה לאיש קשר אחד או יותר שהוסרו מהפרויקט הזה. רענן את הדף ונסה שוב.',
	365: 'אתה מנסה לערוך מאפיינים של איש קשר אחד או יותר שהוסרו מפרויקט זה: {0} רענן את הדף ונסה שוב.',
	366: 'אתה יכול לערוך מאפיינים רק עבור אנשי קשר השייכים לישויות שאתה מנהל. אנשי הקשר הבאים שייכים לישויות שאינך מנהל: {0}',
	367: 'העמודה המותאמת אישית שאתה עורך נמחקה על ידי חבר צוות אחר. רענן את הדף ונסה שוב.',
	368: 'אופציית העמודה המותאמת אישית שאתה עורך נמחקה על ידי חבר צוות אחר. רענן את הדף ונסה שוב.',
	369: 'עליך להיות אחראי פרויקט כדי לבצע פעולה זו.',
	370: 'אתה יכול לערוך מאפיינים רק עבור אנשי קשר השייכים לישויות שאתה מנהל. אנשי הקשר הבאים שייכים לישויות שאינך מנהל: {0}',
	372: 'עליך להיות אחראי פרויקט כדי לבצע פעולה זו.',
	373: 'לא ניתן למחוק בעל פרויקט מרשימת אנשי הקשר. עבור אל אשף הפרויקט כדי לבצע את הפעולה המבוקשת.',
	374: 'אינך יכול להסיר את עצמך אחראי על הפרויקט מהפרויקט הזה.',
	375: 'לא ניתן להסיר את האחראי האחרון על הפרויקט מהפרויקט. חייב להישאר אחראי אחד לפחות על פרויקט.',
	376: 'עליך להיות אחראי על הפרויקט בכדי להוסיף/להסיר אחראי על הפרויקט או אדמין (Entity Admin) מהפרויקט. לא ניתן להסיר את אנשי הקשר הבאים: {0}',
	378: 'לא ניתן להסיר את הדומיין מכיוון שהוא נמצא בשימוש על ידי איש קשר בדף רשימת אנשי הקשר של פרויקט פיקוח זה. עבור לדף רשימת אנשי הקשר והסר אנשי קשר עם הדומיין הזה, ולאחר מכן חזור לכאן כדי להסיר את הדומיין.',
	502: 'הבקשה לקבלת כל התקשרויות נכשלה. רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית.',
	503: 'אין לך גישה עבור הלקוחות שנבחרו.',
	601: 'הבקשה לקבלת הלקוחות נכשלה. רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית.',
	1605: 'המשתמש שנבחר כבר קיים.',

	1803: 'פעולת תג בוצעה עם נתוני פרויקט לא חוקיים, אנא רענן את הדף ונסה שוב. אם הבעיה נמשכת, אנא צור קשר עם התמיכה הטכנית לקבלת סיוע נוסף.',
	1804: 'עליך להיות אחראי פרויקט עבור פרויקט זה כדי לבצע פעולת תג זו.',
	1901: 'קריאת ה-API של שליחת הודעה נכשלה.',
	1902: 'ההודעה לא יכולה להיות ריקה.',
	1903: 'אורך ההודעה המותר הוא 200 תווים.',
	1904: 'אורך הטקסט המותר להתקשרות חוזרת הוא 50 תווים.',
	1905: 'אורך ה-URI להתקשרות חוזרת הוא 50 תווים.',
	1906: 'עליך לבחור לפחות מסנן אחד כדי להמשיך.',
	1907: 'לא ניתן לחזור על נמענים.',
	1908: 'תיק הביקורת לא יכול להיות ריק.',
	1909: 'סוג ההודעה אינו ערך חוקי.',
	1910: 'הנמען לא יכול להיות ערך ריק.',
	1911: 'הודעת toast לא יכולה להיות ריקה.',
	1912: 'סוג הנמען אינו ערך חוקי.',
	1913: 'אין לך את הגישה המתאימה לשלוח התראה. דבר עם האחראי על הפרויקט או מנהל הישות כדי לבקש גישה.',
	1914: 'ניתן לשלוח התראות רק לאנשי קשר פנימיים. בדוק את נמעני ההודעה והסר אנשי קשר חיצוניים כדי להמשיך.',
	2101: 'שירות ה-  EY Policy Authoring, Approvals and Notification Service אינו זמין כעת. איננו יכולים לאשר אם כל הנהלים הרלוונטיים הושלמו. אם לא סקרת את הנהלים הרלוונטיים, רענן את הדף ונסה שנית. אם הבעיה נמשכת, פנה לתמיכה הטכנית.',

	// Reconciliation
	2701: 'הקריאה לקבלת כל ההתאמות נכשלה',
	2702: 'בקשה לא חוקית.',
	2703: 'הקריאה לקבלת כל ההתאמות לפי מזהה ID נכשלה',
	2704: 'הקריאה לקבלת כל הסיכונים לפי מזהה ID נכשלה',
	2705: 'הפרויקט לא נמצא במסד הנתונים.',
	2706: 'הסעיף לא נמצא במסד הנתונים.',
	2707: 'ההתקשרות לא נמצאה במסד הנתונים.',
	2708: 'יצירת הערה נכשלה.',
	2709: 'תגובה כבר נוצרה. רענן את הדף ונסה שוב.',
	2710: 'הבקשה לתיקון סעיף ברמת הישות המוחזקת בקבוצה נכשלה.',
	2711: 'הסעיף ברמת הישות המוחזקת בקבוצה לא נמצא במסד הנתונים.',
	2712: 'הערת רציונל לא יכולה להיות ריקה.',
	2713: 'הערת רציונל לא יכולה לכלול יותר מ-4000 תווים.',
	2714: 'הסיכון של הישות המוחזקת בקבוצה לא נמצא.',
	2715: 'הישות המוחזקת בקבוצה לא נמצאה.',
	2716: 'Risk was not found.',
	2717: 'Invalid group risk status value.',
	2718: 'הבקשה לעדכון ההתאמה נכשלה.',
	2719: 'Patch group component risk comment call failed. Refresh the page and try again.',
	2720: 'פריט זה נערך או נמחק על ידי משתמש אחר. אנא רענן ונסה שוב.',
	2721: 'תגובה כבר נוצרה. רענן את הדף ונסה שוב.',
	2722: 'Account is deleted.'
};

export const clientValidationErrors = {
	ErrorAtleastOneEngagementAssociationRequired: 'חבר לפחות תיק ביקורת אחד לתרשים הארגוני על מנת להמשיך.',
	ErrorAtleastOneGroupAssociationRequired: 'חבר לפחות קבוצה אחת לתרשים האירגוני על מנת להמשיך.',
	ErrorStep2DataNotComplete: 'הזן שם לכל ישות בתרשים האירגוני על מנת להמשיך.'
};

export const engagementsViewBy = [{
		id: 0,
		label: 'הכול',
		value: 'הכול'
	},
	{
		id: 1,
		label: 'לפי מדינה',
		value: 'מדינה',
		groupAttributeName: 'שם מדינה'
	},
	{
		id: 2,
		label: 'לפי המשרד הראשי',
		value: 'לפי איזור (Region)',
		groupAttributeName: 'שם איזור (Region)'
	},
	{
		id: 3,
		label: 'לפי סוג מעורבות',
		value: 'סוג',
		groupAttributeName: 'profileNature'
	}
];

export const milestones = [{
		id: 1,
		label: 'היקף',
		auditPhaseId: 1,
		value: 1
	},
	{
		id: 2,
		label: 'אסטרטגיית תת התהליך המהותי (SCOT)',
		auditPhaseId: 1,
		value: 2
	},
	{
		id: 3,
		label: 'Walkthroughs',
		auditPhaseId: 2,
		value: 3
	},
	{
		id: 4,
		label: 'טסטים על בקרות בתקופות ביניים',
		auditPhaseId: 2,
		value: 4
	},
	{
		id: 5,
		label: 'בדיקות מבססות בתקופות ביניים',
		auditPhaseId: 2,
		value: 5
	},
	{
		id: 6,
		label: 'Walkthroughs (תהליכי סוף השנה)',
		auditPhaseId: 2,
		value: 6
	},
	{
		id: 7,
		label: 'טסטים על בקרות בסוף שנה',
		auditPhaseId: 2,
		value: 7
	},
	{
		id: 8,
		label: 'בדיקות מבססות בסוף שנה',
		auditPhaseId: 2,
		value: 8
	},
	{
		id: 9,
		label: 'מסקנה',
		auditPhaseId: 3,
		value: 9
	},
	{
		id: 10,
		label: 'לא רלוונטי',
		auditPhaseId: 2,
		value: 10
	},
	{
		id: 11,
		label: 'ביצוע הביקורת',
		auditPhaseId: 2,
		value: 11
	},
	{
		id: 12,
		label: 'פעילויות איכות בשלב ההיקף והאסטרטגיה',
		auditPhaseId: 1,
		value: 12
	},
	{
		id: 13,
		label: 'תכנון ואסטרטגיה אחרים',
		auditPhaseId: 1,
		value: 13
	},
	{
		id: 14,
		label: 'CRA',
		auditPhaseId: 1,
		value: 14
	},
	{
		id: 15,
		label: 'הערכת סיכונים ומהותיות',
		auditPhaseId: 1,
		value: 15
	},
	{
		id: 16,
		label: 'גיבוש סופי של היקף ואסטרטגית הביקורת',
		auditPhaseId: 1,
		value: 16
	},
	{
		id: 17,
		label: 'Post-interim project management',
		auditPhaseId: 2,
		value: 17
	}
];

export const daysOptions = [{
		id: daySelection.tomorrow,
		value: daySelection.tomorrow,
		label: 'מחר'
	},
	{
		id: daySelection.next3days,
		value: daySelection.next3days,
		label: '3 הימים הבאים'
	},
	{
		id: daySelection.next5days,
		value: daySelection.next5days,
		label: '5 הימים הבאים'
	},
	{
		id: daySelection.next10days,
		value: daySelection.next10days,
		label: '10 הימים הבאים'
	},
	{
		id: daySelection.next30days,
		value: daySelection.next30days,
		label: '30 הימים הבאים'
	}
];

export const auditPhases = [{
		id: 1,
		label: 'היקף ואסטרטגיה'
	},
	{
		id: 2,
		label: 'ביצוע הביקורת'
	},
	{
		id: 3,
		label: 'מסקנה'
	}
];

export const findings = [{
		id: 1,
		label: 'הצהרות מוטעות',
		subTitle: 'הפרשי ביקורת לפי סוג'
	},
	{
		id: 2,
		label: 'ליקויים',
		subTitle: 'ליקויים לפי חומרה'
	}
];
export const risks = [{id: 1, label: '', subTitle: 'By type'}];

export const auditStrategies = [{
		id: 1,
		label: 'ביקורת מבססת',
		subTitle: 'נהלים מבססים לפי סוג'
	},
	{
		id: 2,
		label: 'בקרות',
		subTitle: 'בקרות על ידי אסטרטגיית בדיקה'
	},
	{
		id: 3,
		label: 'IT',
		subTitle: 'נהלי IT על ידי אסטרטגיית בדיקה'
	}
];

export const auditInsights = [{
		id: 1,
		label: 'לפי תפקיד בקבוצה'
	},
	{
		id: 2,
		label: 'הכול'
	}
];

export const projectStatus = {
	Active: 'פעיל',
	Draft: 'טיוטה',
	Cancel: 'בטל',
	Complete: 'הסתיים',
	Delete: 'מחק'
};

export const ProjectStatusLabels = [{
		label: 'ראשוני',
		id: 1,
		value: 'Initial'
	},
	{
		label: 'טְיוּטָה',
		id: 2,
		value: 'Draft'
	},
	{
		label: 'פעיל',
		id: 3,
		value: 'Active'
	},
	{
		label: 'מבוטל',
		id: 4,
		value: 'Cancelled'
	},
	{
		label: 'הושלם',
		id: 5,
		value: 'Completed'
	},
	{
		label: 'נמחק',
		id: 6,
		value: 'Delete'
	}
];

export const projectTeamEngagementTableGroup = [{
		id: 1,
		label: 'הקצאות מכין'
	},
	{
		id: 2,
		label: 'הקצאות לסוקר'
	}
];

export const archiveReportQualifiedType = [{
		id: archiveReportQualifiedTypeId.notSelected,
		label: 'לא נבחר'
	},
	{
		id: archiveReportQualifiedTypeId.unqualifiedWithEmphasisOfMatter,
		label: 'חוות דעת שאינה בנוסח האחיד - עם פסקת הדגש עניין (הפניית תשומת לב)'
	},
	{
		id: archiveReportQualifiedTypeId.unqualifiedWithoutEmphasisOfMatter,
		label: 'חוות דעת שאינה בנוסח האחיד - ללא פסקת הדגש עניין (הפניית תשומת לב)'
	},
	{
		id: archiveReportQualifiedTypeId.qualifiedWithEmphasisOfMatter,
		label: 'חוות דעת בנוסח האחיד - עם פסקת הדגש עניין (הפניית תשומת לב)'
	},
	{
		id: archiveReportQualifiedTypeId.qualifiedWithoutEmphasisOfMatter,
		label: 'חוות דעת בנוסח האחיד - ללא פסקת הדגש עניין (הפניית תשומת לב)'
	},
	{
		id: archiveReportQualifiedTypeId.adverseOpinionWithEmphasisOfMatter,
		label: 'חוות דעה שלילית - עם פסקת הדגש עניין (הפניית תשומת לב)'
	},
	{
		id: archiveReportQualifiedTypeId.adverseOpinionWithoutEmphasisOfMatter,
		label: 'חוות דעה שלילית - ללא פסקת הדגש עניין (הפניית תשומת לב)'
	},
	{
		id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithEmphasisOfMatter,
		label: 'המנעות ממתן חוות דעת - עם פסקת הדגש עניין (הפניית תשומת לב)'
	},
	{
		id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithoutEmphasisOfMatter,
		label: 'המנעות ממתן חוות דעת - ללא פסקת הדגש עניין (הפניית תשומת לב)'
	}
];

export const strategyTableGroup = [{id: 1, label: ''}];

export const roleForMember = [{
		id: roles.partnerInCharge,
		label: 'השותף האחראי על תיק הביקורת',
		roleAbbreviation: 'PTR IN CHG'
	},
	{
		id: roles.engagementPartner,
		label: 'השותף האחראי על תיק הביקורת',
		roleAbbreviation: 'EP'
	},
	{
		id: roles.executiveDirector,
		label: 'ED',
		roleAbbreviation: 'EXEC DIR'
	},
	{
		id: roles.principal,
		label: 'שותף',
		roleAbbreviation: 'שותף'
	},
	{
		id: roles.seniorManager,
		label: "סניור מנג'ר",
		roleAbbreviation: 'SR.MANAGER'
	},
	{
		id: roles.manager,
		label: "מנג'ר",
		roleAbbreviation: "מנג'ר"
	},
	{
		id: roles.senior,
		label: 'סניור',
		roleAbbreviation: 'סניור'
	},
	{
		id: roles.staff,
		label: 'מתמחה',
		roleAbbreviation: 'מתמחה'
	},
	{
		id: roles.intern,
		label: 'מתמחה',
		roleAbbreviation: 'Intrn'
	},
	{
		id: roles.engagementQualityReviewer,
		label: 'שותף מלווה EQR',
		roleAbbreviation: 'EQR'
	},
	{
		id: roles.otherPartner,
		label: 'שותף אחר',
		roleAbbreviation: 'OTHER PTR'
	},
	{
		id: roles.gdsStaff,
		label: 'GDS - Staff',
		roleAbbreviation: 'GDS-STAFF'
	},
	{
		id: roles.advisory,
		label: 'ייעוץ (ITRATASHuman Capital or Other)',
		roleAbbreviation: 'ADV'
	},
	{
		id: roles.tax,
		label: 'TAX',
		roleAbbreviation: 'TAX'
	},
	{
		id: roles.executiveSupportServices,
		label: 'שירותי תמיכה ניהוליים',
		roleAbbreviation: 'ESS'
	},
	{
		id: roles.generalCounsel,
		label: 'יועץ משפטי',
		roleAbbreviation: 'GCO'
	},
	{
		id: roles.auditQualityReviewer,
		label: 'סוקר AQR',
		roleAbbreviation: 'AQR'
	},
	{
		id: roles.mlComponentTeam,
		label: 'ML צוות הביקורת של ישות מדווחת (CT)',
		roleAbbreviation: 'MCT'
	},
	{
		id: roles.clientSupervisor,
		label: 'Client Supervisor',
		roleAbbreviation: 'ClntS'
	},
	{
		id: roles.clientStaff,
		label: 'צוות הלקוח',
		roleAbbreviation: 'ClntSt'
	},
	{
		id: roles.internalAuditSupervisor,
		label: 'אחראי על הביקורת הפנימית',
		roleAbbreviation: 'IASup'
	},
	{
		id: roles.internalAuditStaff,
		label: 'צוות ביקורת פנימית',
		roleAbbreviation: 'IASt'
	},
	{
		id: roles.regulator,
		label: 'רגולטור',
		roleAbbreviation: 'Reglr'
	},
	{
		id: roles.other,
		label: 'אחר (למשל בדיקה נאותות)',
		roleAbbreviation: 'אחרים'
	},
	{
		id: roles.office,
		label: 'משרד',
		roleAbbreviation: 'כבוי'
	},
	{
		id: roles.area,
		label: 'אזור',
		roleAbbreviation: 'אזור'
	},
	{
		id: roles.industry,
		label: 'תעשייה',
		roleAbbreviation: 'IND'
	},
	{
		id: roles.national,
		label: 'National',
		roleAbbreviation: 'NAT'
	},
	{
		id: roles.global,
		label: 'Global',
		roleAbbreviation: 'GBL'
	},
	{
		id: roles.gsdSenior,
		label: 'GDS - Senior',
		roleAbbreviation: 'GDS-SENIOR'
	},
	{
		id: roles.gsdManager,
		label: 'GDS - Manager',
		roleAbbreviation: 'GDS-MANAGER'
	}
];

export const toggleCCPEntityOptions = [{
		id: toggleCCPEntityDetail.comingDue,
		label: labels.comingDue
	},
	{
		id: toggleCCPEntityDetail.overdue,
		label: labels.taskStatusOverdue
	},
	{
		id: toggleCCPEntityDetail.returned,
		label: labels.returned
	}
];

export const reportReadinessSeries = [
	{id: readinessReportCategories.comingDueOver2Weeks, label: `> 2{break}${labels.weeks}`},
	{id: readinessReportCategories.comingDue12Weeks, label: `1-2{break}${labels.weeks}`},
	{id: readinessReportCategories.comingDueUnder1Week, label: `< 1{break}${labels.week}`},
	{id: readinessReportCategories.overDueUnder1Week, label: `< 1{break}${labels.week}`},
	{id: readinessReportCategories.overDue12Weeks, label: `1-2{break}${labels.weeks}`},
	{id: readinessReportCategories.overDueOver2Weeks, label: `> 2{break}${labels.weeks}`}
];

export const natureOfEngagementsLabels = {
	[natureOfEngagements.auditStatements.id]: 'ביקורת דוחות כספיים',
	[natureOfEngagements.integratedStatements.id]: 'ביקורת משולבת של דוחות כספיים ובקרה פנימית על דיווח כספי',
	[natureOfEngagements.reviewStatements.id]: 'סקירת דוחות כספיים ביניים',
	[natureOfEngagements.nonAuditAccount.id]: 'מעורבות לא ביקורתית עם פונקציונליות חשבון/טענה/SCOT',
	[natureOfEngagements.nonAuditWorkPlan.id]: 'מעורבות שאינה ביקורתית עם פונקציונליות של תוכנית עבודה בלבד'
};

export const AdminRoles = [{
		label: 'קורא מנהל אפליקציה',
		id: 1
	},
	{
		label: 'כותב מנהל אפליקציה',
		id: 2
	},
	{
		label: 'סופר מנהל אפליקציה',
		id: 3
	}
];

export const userType = [{
		value: 1,
		label: 'פנימי'
	},
	{
		value: 2,
		label: 'חיצוני'
	}
];

export const MessageType = [{
		value: 1,
		label: 'דואל'
	},
	{
		value: 2,
		label: 'הודעה'
	}
];

export const groupRole = [{
		value: 1,
		label: 'צוות הביקורת הראשי (PT)',
		id: 1,
		selected: false,
		disabled: false
	},
	{
		value: 2,
		label: 'צוות איזורי',
		id: 2,
		selected: false,
		disabled: false
	},
	{
		value: 3,
		label: 'צוות הביקורת של ישות מדווחת',
		id: 3,
		selected: false,
		disabled: false
	},
	{
		value: 4,
		label: 'דיווח של צוות הביקורת של ישות מדווחת למבקרים שאינם EY (Non-EY Auditors)',
		id: 4,
		selected: false,
		disabled: false
	},
	{
		value: 5,
		label: 'לא ישים',
		id: 5,
		selected: false,
		disabled: false
	}
];

export const accessLogResource = [{
		id: 1,
		label: 'אנשי קשר להוספה'
	},
	{
		id: 2,
		label: 'אנשי קשר להסרה'
	}
];

export const addContactsTabsResource = [{
		id: 1,
		label: 'גִישָׁה'
	},
	{
		id: 2,
		label: 'מאפיינים'
	},
	{
		id: 3,
		label: 'תגים'
	}
];

export const tags = [{
		name: 'שותף ביקורת',
		id: 'auditPartner'
	},
	{
		name: 'מנהל תיק הביקורת',
		id: 'auditEngagementManager'
	},
	{
		name: 'מנהל התקשרות GDS',
		id: 'gdsEngagementManager'
	},
	{
		name: 'שותף מס',
		id: 'taxPartner'
	},
	{
		name: 'מנהל התקשרות TAX',
		id: 'taxEngagementManager'
	},
	{
		name: 'שותף FAIT',
		id: 'faitPartner'
	},
	{
		name: 'מנהל התקשרות FAIT',
		id: 'faitEngagementManager'
	},
	{
		name: 'שותף ייעוץ',
		id: 'advisoryPartner'
	},
	{
		name: 'מנהל מעורבות Advisory',
		id: 'advisoryEngagementManager'
	},
	{
		name: 'מוּמחֶה',
		id: 'specialist'
	},
	{
		name: 'מנהל לקוח',
		id: 'clientadministrator'
	}
];

export const dashboardContactViews = [{
		id: dashboardTabId.milestones,
		value: dashboardViewsConstants.milestones,
		tooltipText: 'התקדמות הביקורת לפי אבן דרך (milestones)',
		key: 'Milestones',
		checked: false
	},
	{
		id: dashboardTabId.projectManagement,
		value: dashboardViewsConstants.projectManagement,
		tooltipText: 'סטטוס הערות ומטלות ביקורת, כולל פריטים באיחור. לא ניתן להעניק למשתמשים חיצוניים גישה ללוח המחוונים של ניהול הפרויקטים.',
		key: 'ניהול פרויקטים',
		checked: false
	},
	{
		id: dashboardTabId.groupAudit,
		value: dashboardViewsConstants.groupAudit,
		tooltipText: 'סטטוס צוות ביקורת ראשי ושל ישויות מוחזקות, לרבות כאלו שהוחזרו ושתאריך היעד שלהם חלף',
		key: 'ביקורת קבוצתית',
		checked: false
	},
	{
		id: dashboardTabId.groupRiskAssessment,
		value: dashboardViewsConstants.groupRiskAssessment,
		tooltipText: 'תצוגה של הערכת סיכונים ברמת הקבוצה לרבות צוותי הביקורת של הישויות המוחזקות וצוות הביקורת הראשי. תצוגה זו לא תהיה גלויה ללקוחות.',
		key: 'הערכת סיכונים קבוצתית',
		checked: false
	},
	{
		id: dashboardTabId.canvasClientPortal,
		value: dashboardViewsConstants.ccp,
		tooltipText: 'סטטוס הבקשה, לרבות תאריך היעד, פריטים שתאריך היעד שלהם חלף ופריטים שהוחזרו',
		key: 'EY Canvas Client Portal',
		checked: false
	},
	{
		id: dashboardTabId.insights,
		value: dashboardViewsConstants.insights,
		tooltipText: 'השוואת סיכונים, נהלים מבססים, אסטרטגיית בקרה וממצאים בין צוותים ראשוניים ומרכיבים. לא ניתן להעניק למשתמשים חיצוניים גישה למרכז השליטה של Insights.',
		key: 'תובנות',
		checked: false
	},
	{
		id: dashboardTabId.reporting,
		value: dashboardViewsConstants.reporting,
		tooltipText: 'דיווח על מוכנות, שינויים ומצב השלמת משימה לפי מדינה',
		key: 'דוחות',
		checked: false
	}
];

export const colorOptionsLabels = {
	red: 'אָדוֹם',
	orange: 'כתום',
	teal: 'ירוק כחלחל',
	blue: 'כחול',
	purple: 'סגול',
	green: 'ירוק',
	yellow: 'צהוב',
	gray: 'אפור'
};

export const exportToExcelLabels = {
	yes: 'כן',
	no: 'לא',
	exportData: labels.exportData,
	exportButtonTitle: 'לחץ כאן כדי להוריד מידע מפורט של בקשת הלקוח עבור הישויות שנבחרו בתרשים הארגוני מצד שמאל של פרויקט EY Oversight זה',
	projectInfo: 'מידע על הפרויקט',
	exportDate: 'תאריך ייצוא',
	engagementName: labels.engagementNameLabel,
	engagementId: labels.engagementId,
	requestItemNumber: 'בקש מספר פריט',
	requestTitle: 'כותרת הבקשה',
	priority: 'עדיפות',
	status: labels.status,
	receivedDate: 'תאריך קבלה',
	dueDate: 'תאריך יעד',
	overdue: labels.overdueLabel,
	eyContact: 'איש קשר של EY',
	assignedTo: 'הוקצה ל',
	statusLabels: [{
			id: 1,
			label: 'טְיוּטָה'
		},
		{
			id: 2,
			label: 'אין איש קשר ללקוח'
		},
		{
			id: 3,
			label: 'נשלח'
		},
		{
			id: 4,
			label: 'שגיאת מערכת'
		},
		{
			id: 5,
			label: 'איש קשר לא חוקי ללקוח'
		},
		{
			id: 6,
			label: 'ממתין למענה'
		},
		{
			id: 7,
			label: 'התקבל'
		},
		{
			id: 8,
			label: 'התקבל'
		},
		{
			id: 9,
			label: 'הוחזר'
		},
		{
			id: 10,
			label: 'נדחה'
		},
		{
			id: 11,
			label: 'השליחה מתבצעת'
		},
		{
			id: 12,
			label: 'קבלה בתהליך'
		},
		{
			id: 13,
			label: 'דחייה בתהליך'
		},
		{
			id: 14,
			label: 'מחיקה בתהליך'
		},
		{
			id: 15,
			label: 'החזרה בתהליך'
		},
		{
			id: 16,
			label: 'מתן מענה בתהליך'
		},
		{
			id: 17,
			label: 'נמחק'
		},
		{
			id: 18,
			label: 'הוחזר איש קשר לא חוקי ללקוח'
		},
		{
			id: 19,
			label: 'איחזור בתהליך'
		},
		{
			id: 20,
			label: 'אוחזר'
		},
		{
			id: 21,
			label: 'השלמה בתהליך'
		},
		{
			id: 22,
			label: 'איחזור בתהליך'
		}
	],
	priorityTypeLabels: [{
			id: 1,
			label: 'Low'
		},
		{
			id: 2,
			label: 'Medium'
		},
		{
			id: 3,
			label: 'High'
		},
		{
			id: 4,
			label: 'Critical'
		}
	],

	risks: {
		exportButtonTitle: 'לחץ כאן כדי להוריד מידע מפורט אודות נתוני הערכת הסיכונים עבור הישויות שנבחרו בתרשים הארגוני בצד שמאל של פרויקט EY Oversight זה.',
		tabTitle: 'פרטי הערכת הסיכונים',
		columns: {
			engagementName: labels.engagementNameLabel,
			engagementId: labels.engagementId,
			accountName: 'שם סעיף / גילוי',
			pspIndex: 'אינדקס PSP',
			accountType: 'ייעוד',
			assertion: 'יעד הנהלה',
			inherentRisk: 'סיכון שבמהות (Inherent Risk)',
			controlRisk: 'בקרת סיכון',
			craValue: 'הערכת הסיכון המשולב (CRA)',
			riskType: 'סוג הסיכון',
			riskName: 'שם הסיכון',
			relatedTasks: 'משימות קשורות',
			taskStatus: 'סטטוס המשימה'
		}
	},
	exportButtonTooltip: 'לחץ כאן כדי להוריד נתוני התאמה מפורטים עבור צוות הביקורת של חברת האם (PT) וצוות הביקורת של ישות מוחזקת (CT) הקשור.',
	primaryTeamEngagementName: 'שם ההתקשרות של חברת האם (PT)',
	componentTeamEngagementName: 'שם ההתקשרות של צוות הביקורת של ישות מוחזקת (CT)',
	howToUseThisExport: 'כיצד להשתמש בייצוא זה:',
	howToUseThisExportText: 'The information in the "Accounts" and "Risks" tabs of this excel file summarizes the ​reconciliation of the accounts and risks included in the Primary Team group risk assessment communication to the accounts and risks existing in the component EY Canvas engagement.\n On the "Accounts" tab, we are displaying the list of relevant Primary and component team accounts. In addition, we are displaying the details of each Primary and component team account, including account name, associated PSP index(es), account designation and the associated assertions. If Primary and component team account(s) have been related or marked assessed in Oversight - Reconciliation data, the Primary team and component team account(s) rows below will be grouped together. Additionally, comments left in Oversight - Reconciliation data will be reflected below.\n On the "Risks" tab, we are displaying the list of relevant Primary and component team risks. In addition, we are displaying the details of each Primary and component team risk, including risk name, risk designation, accounts related to the risks and the associated PSP index(es) to the accounts. If Primary and component team risk(s) have been related or marked assessed in Oversight - Reconciliation data, the Primary team and component team risk(s) rows below will be grouped together. Additionally, comments left in Oversight - Reconciliation data will be reflected below.',
	reconciliationComponentExportTabTitle: 'סעיפים',
	reconciliationComponentExport: {
		status: 'סטטוס',
		primaryTeamAccountName: 'Primary Team account name',
		componentTeamAccountNames: 'שמות הסעיפים של צוות הביקורת של ישות מוחזקת (CT)',
		pspIndexes: 'אינדקס(ים) PSP',
		designation: 'ייעוד',
		c: 'C',
		eo: 'E/O',
		mv: 'M/V',
		ro: 'R&O',
		pd: 'P&D',
		comment: 'הערה'
	},
	groupRiskStatusLabels : {
		[groupRiskStatus.open]: "פתח",
		[groupRiskStatus.assessed]: "מוערך",
		[groupRiskStatus.mapped]: "מופה",
		[groupRiskStatus.unmapped]: "לא מופה",
		[groupRiskStatus.notApplicable]: "לא ישים",
		[groupRiskStatus.systemReOpened]: "Open"
	},
	reconciliationExportTabRisks: 'Risks',
	reconciliationExport: {
		status: 'סטטוס',
		primaryTeamRiskName: 'Primary team risk name',
		componentTeamRiskName: 'Component team risk name(s)',
		riskDesignation: 'Risk designation',
		accountsRelatedToRisk: 'Account(s) related to risk',
		c: 'C',
		eo: 'E/O',
		mv: 'M/V',
		ro: 'R&O',
		pd: 'P&D',
		comment: 'הערה'
	}
};

export const accountDesignationsLabels = {
	[accountDesignations.significantAccount]: 'Significant account',
	[accountDesignations.limitedRiskAccount]: 'Limited risk account',
	[accountDesignations.insignificantAccount]: 'לא משמעותי',
	[accountDesignations.otherAccount]: 'אחרים',
	[accountDesignations.significantDisclosure]: 'גילוי משמעותי'
};

export const riskDesignationsLabels = {
	[riskTypeIds.significant]: 'Significant Risk',
	[riskTypeIds.fraud]: 'Fraud Risk',
	[riskTypeIds.insignificant]: 'Insignificant Risk'
};
